import { messageService } from './message.service';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpEvent,
  HttpRequest,
  HttpParams,
} from '@angular/common/http';
import { catchError, map, retry, switchMap, timeout } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { oneQmsUsersInterface } from '../app/users/users.component';
import { Router } from '@angular/router';
import { qmsSettingsInterface } from './admin/qms-settings-vw/qmsSettingsObj';
import { dmsSettingsInterface } from './admin/dms-settings/dmsSettingsObj';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  baseUrl = 'https://predev.one-qms.com/oneqms-service-v1/oneqms';
 // baseUrl = "http://localhost:8080/oneqms";

  private readonly IP_API_URL = 'https://checkip.amazonaws.com';
  private readonly TRAY_URL = 'https://oneqms-printer';

  excutionDetails: any;
  fromTypeData: any;
  categoriesList: any = [];
  trainingData: any;
  isProcessingRep: boolean = false;
  parentFolderId: any;
  folderTypeForTree: any;
  orgVal: any;
  documentTypeOfFolder: any;
  documentsBreadcrumbList: any = [];
  myTaskCount: any = -1;
  myTaskValue: any = 'All';
  prevDocumentId: any = null;
  prevDocVersion: any = null;
  myTraining: any = 'mainPage';
  flexiFieldModule: any = 'mainPage';
  executionSetupId: any = null;
  qmsGroupData: any = {};
  organizationDetails: any;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    }),
  };

  getContentTypeByExtension(extn: string): string {
    switch ((extn || '').toLowerCase()) {
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'png':
        return 'image/png';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'txt':
        return 'text/plain';
      default:
        return 'application/octet-stream';
    }
  }

  get getOneQmsDateFormat(): string {
    const fmt = this.organizationDetails?.htmlDateFormat;
    if (!fmt) return 'dd-MMM-yyyy';

    return fmt.replaceAll('YYYY', 'yyyy').replaceAll('DD', 'dd');
  }

  base64ToBlob(base64Data: string, contentType: string = ''): Blob {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    const sliceSize = 512;

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.codePointAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly message: messageService
  ) { }

  validateSession() {
    let headers = new HttpHeaders();
    headers = headers.set('X-Skip-Loader', 'true');
    return this.http.get(`${this.baseUrl}/session/validate`, {
      headers,
      withCredentials: true,
    });
  }

  refreshSession() {
    let headers = new HttpHeaders();
    headers = headers.set('X-Skip-Loader', 'true');
    return this.http.get(this.baseUrl + '/session/refresh', {
      headers,
      withCredentials: true,
    });
  }

  remainingSession() {
    let headers = new HttpHeaders();
    headers = headers.set('X-Skip-Loader', 'true');
    return this.http.get(this.baseUrl + '/session/remainingTime', {
      headers,
      withCredentials: true,
    });
  }

  setRouteOfMyTask(arg0: string) {
    this.myTaskValue = arg0;
  }

  getIpAddress(): Observable<string> {
    return this.http.get(this.IP_API_URL, { responseType: 'text' }).pipe(
      timeout(5000),
      retry(2),
      map((res) => res.trim()),
      catchError((err) => {
        console.error('IP API failed:', err);
        return of('UNKNOWN');
      }),
    );
  }
  getOrgVal() {
    return this.orgVal;
  }
  setOrgVal(arg0: string) {
    this.orgVal = arg0;
  }

  getRouteOfMyTask() {
    return this.myTaskValue;
  }

  loginUser(logCredential: any) {
    return this.http.post(`${this.baseUrl}` + '/users/login', logCredential);
  }

  loginUserSetToken(logCredential: any) {
    return this.http.post(`${this.baseUrl}` + '/users/settoken', logCredential);
  }

  checkSessionExists() {
    return this.http.get(`${this.baseUrl}` + '/users/session/exists');
  }

  logOutUser() {
    return this.http.put(`${this.baseUrl}` + '/users/logout', {});
  }

  connectRedis() {
    return this.http.get(`${this.baseUrl}` + '/redis/test');
  }

  overrideLogin(override: any) {
    return this.http.post(`${this.baseUrl}` + '/users/override', override);
  }

  validateUser(logCredential: any) {
    return this.http.post(`${this.baseUrl}` + '/users/validate', logCredential);
  }

  userCount(userName: string) {
    return this.http.get(`${this.baseUrl}` + '/users/' + userName + "/userCount");
  }

  userOrgName(userName: string) {
    return this.http.get(`${this.baseUrl}` + '/users/' + userName + "/getUserOrgName");
  }

  managerCount() {
    return this.http.get(`${this.baseUrl}` + '/users/forTrainingDashboard');
  }

  getOneQmsUsers() {
    return this.http.get(`${this.baseUrl}` + '/users/getOneQmsUsers');
  }

  forgotPassword(forgotPassword: any) {
    return this.http.post(`${this.baseUrl}` + '/users/forgotPasswordByOrgShortName', forgotPassword);
  }

  decryptPassword(decrypt: any) {
    return this.http.post(`${this.baseUrl}` + '/common', decrypt);
  }

  validateUserForEmail(encrypt: any) {
    return this.http.post(`${this.baseUrl}` + '/common/validate', encrypt);
  }

  resetPassword(resetCredential: any) {
    return this.http.post(`${this.baseUrl}` + '/users/resetUserPasswordByOldPassword', resetCredential);
  }

  getManagerList(userId: any) {
    return this.http.get(`${this.baseUrl}` + '/users/' + userId + "/managerList");
  }

  userDetailsByName(userName: any) {
    return this.http.get(`${this.baseUrl}` + '/users/' + userName + "/userDetailsByName");
  }

  userOrgsByName(userDetails: any) {
    return this.http.post(`${this.baseUrl}` + '/users/listOfOrg', userDetails);
  }

  userDetails(userId: number) {
    return this.http.get(`${this.baseUrl}` + '/users/' + userId + "/managerList");
  }

  getManagerDetails(userId: number) {
    return this.http.get(`${this.baseUrl}` + '/users/' + userId + "/getManagerDetails");
  }

  createOneQmsUsers(
    oneQmsUsersFieldData: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/users',
        JSON.stringify(oneQmsUsersFieldData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  updateOneQmsUsers(
    oneQmsUsersFieldData: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .put<oneQmsUsersInterface>(
        this.baseUrl + '/users',
        JSON.stringify(oneQmsUsersFieldData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  //Reset Users Password
  reserUserPassword(resetData: any): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/users/resetUserPasswordByOldPassword',
        JSON.stringify(resetData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  resetUserPasswordByAdminLevel(reset: any) {
    return this.http.post(`${this.baseUrl}` + '/users/resetUserPasswordByAdminLevel', reset);
  }

  //Active And InActive Users
  activeAndInActiveUser(activeAndInActiveUsers: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(activeAndInActiveUsers),
    };
    return this.http
      .delete<oneQmsUsersInterface>(this.baseUrl + '/users', httpOptions1)
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  getOneQmsUserActiveUserRep(data: any) {
    return this.http.put(`${this.baseUrl}` + '/users/concurentUserList', data);
  }

  usergridddynamicDataMainDashboard(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` +
      '/dynamicgrid/getGridFieldsByDynamicQueryMainDashboard',
      userDetails,
    );
  }
  usergridddynamicDataForTmsReport(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` +
      '/dynamicgrid/getGridFieldsByDynamicQueryForTmsReport',
      userDetails,
    );
  }

  tableFieldsDataType(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getTableDataType',
      userDetails,
    );
  }
  getUserTimezoneDetails() {
    return this.http.get(
      `${this.baseUrl}` +
      '/dynamicgrid/getUserTimezoneDetails'
    );
  }

  getDynamicGridHeaders(obj: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getGridFieldsByProcedure',
      obj,
    );
  }

  getDynamicGridData(obj: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getGridFieldsByDynamicQuery',
      obj,
    );
  }

  Copy(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (Array.isArray(obj)) {
      const arrCopy: any = [];
      for (let i = 0; i < obj.length; i++) {
        arrCopy[i] = this.Copy(obj[i]);
      }
      return arrCopy;
    }

    const objCopy: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        objCopy[key] = this.Copy(obj[key]);
      }
    }
    return objCopy;
  }

  check(): Observable<boolean> {
    let user = '';

    // Check if the user is logged in
    if (user != '') {
      return of(true);
    }
    // Check the access token availability
    if (user == '') {
      return of(false);
    }
    return of(false);
  }

  getTrainingsList(status: any) {
    return this.http.get(
      `${this.baseUrl}` + '/training/' + status + '/byStatus',
    );
  }

  /* This method is not used  */
  getActionTrainings(status: any) {
    return this.http.get(
      `${this.baseUrl}` + '/training/' + status + '/myTasks',
    );
  }

  addOrUpdateTraining(multipartData: any) {
    return this.http.post(`${this.baseUrl}` + '/training', multipartData);
  }

  deleteTraining(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(`${this.baseUrl}` + '/training', httpOptions);
  }

  getTrainingByTrainingIdFirstTime(trainingId: number) {
    return this.http.get(
      `${this.baseUrl}` + '/training/' + trainingId + '/byId',
    );
  }

  getTrainingByTrainingId(trainingId: number, version: number) {
    return this.http.get(
      `${this.baseUrl}` +
      '/training/' +
      trainingId +
      '/' +
      version +
      '/byTrainingIdVersion',
    );
  }

  getCategoriesList() {
    return this.http.get(`${this.baseUrl}` + '/training/categories');
  }

  getAllCategoriesList() {
    return this.http.get(`${this.baseUrl}` + '/training/allcategories');
  }

  getCodeListsByGroup(groupName: string) {
    return this.http.get(
      `${this.baseUrl}` + '/codelists/' + groupName + '/bygroupName',
    );
  }

  getCodeListsByGroupAndModule(groupName: string, module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/codelists/' +
      groupName +
      '/' +
      module +
      '/bygroupNameAndmodule',
    );
  }

  /* Multi Organization */
  getCodeListsByGroupOrg(groupName: string, orgId?: any) {
    return this.http.get(`${this.baseUrl}/codelists/${groupName}`, { params: { ...(orgId != null && { orgId }) } });
  }

  getCodeListsmoduleByGroup(groupName: string) {
    return this.http.get(
      `${this.baseUrl}` + '/codelists/' + groupName + '/module',
    );
  }

  getdistinctCodeListsGroup(module: any) {
    return this.http.get(
      `${this.baseUrl}` + '/codelists/' + module + '/byModuleanddistinctname',
    );
  }

  fetchDepartmentListWithSearchCriteria(searchDepartmentData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/codelists/searchForAudit',
      searchDepartmentData,
    );
  }

  createCodelist(codelistData: any) {
    return this.http.post(`${this.baseUrl}` + '/codelists', codelistData);
  }

  updateCodelist(codelistData: any) {
    return this.http.put(`${this.baseUrl}` + '/codelists', codelistData);
  }

  deleteCodelist(codelistData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: codelistData,
    };
    return this.http.delete(`${this.baseUrl}` + '/codelists', httpOptions);
  }
  createoneQmsDocumentTypes(documentTypesData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsDocumentTypesVw',
      documentTypesData,
    );
  }
  updateoneQmsDocumentTypes(documentTypesData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsDocumentTypesVw',
      documentTypesData,
    );
  }
  deleteoneQmsDocumentTypes(documentTypesData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: documentTypesData,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/oneQmsDocumentTypesVw',
      httpOptions,
    );
  }

  getQmsGroups() {
    return this.http.get(`${this.baseUrl}` + "/qmsGroups/getAllGroups");
  }

  getGroupsModuleCurrentUserVw(module: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsGrMoCuUsVw/' + module + "/byModule2");
  }

  getQmsGroupsByModule(module: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGroups/" + module + "/byModule");
  }

  getQmsGroupByGroupId(groupId: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGroups/" + groupId + "/byGroupId");
  }

  getQmsReportUsers(module: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsGrMoCuUsVw/' + module + "/getReportUsers");
  }

  createQualityGroup(qmsGroupsData: any) {
    return this.http.post(`${this.baseUrl}` + "/qmsGroups", qmsGroupsData);
  }

  updateQualityGroup(qmsGroupsData: any) {
    return this.http.put(`${this.baseUrl}` + "/qmsGroups", qmsGroupsData);
  }

  deleteQualityGroup(qmsGroupsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: qmsGroupsData,
    };
    return this.http.delete(`${this.baseUrl}` + "/qmsGroups", httpOptions);
  }
  //
  getWorkflowByWorkflowId(workflowId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsParallelWorkflows/' +
      workflowId +
      '/byWorkflowId',
    );
  }

  getWorkflowByRefNo(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsParallelWorkflows/' + refNo + '/byRefNo',
    );
  }

  createParallelWorkflow(parallelWorkflowsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsParallelWorkflows',
      parallelWorkflowsData,
    );
  }

  updateParallelWorkflow(parallelWorkflowsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsParallelWorkflows',
      parallelWorkflowsData,
    );
  }

  deleteParallelWorkflow(parallelWorkflowsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: parallelWorkflowsData,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/qmsParallelWorkflows',
      httpOptions,
    );
  }

  performWorkflowButtonOperation(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsParallelWorkflows/performButtonOperation',
      multipartData,
    );
  }

  getWorkflowButtons(qmsActionsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsParallelWorkflows/getButtons',
      qmsActionsData,
    );
  }

  //genRateOOSReport
  //parallelWorkflowActions
  getParallelWorkflowActions(workflowId: any, actionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsParallelWorkFlowActions/' +
      workflowId +
      '/' +
      actionId +
      '/byWorkflowIdActionId',
    );
  }

  createParallelWorkflowActions(parallelWorkflowActionsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsParallelWorkFlowActions',
      parallelWorkflowActionsData,
    );
  }

  updateParallelWorkflowActions(parallelWorkflowActionsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsParallelWorkFlowActions',
      parallelWorkflowActionsData,
    );
  }

  deleteParallelWorkflowActions(parallelWorkflowActionsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: parallelWorkflowActionsData,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/qmsParallelWorkFlowActions',
      httpOptions,
    );
  }

  //parallelWorkflowOOSActions
  getWorkflowOOSActionsByActionId(workflowId: any, actionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oosParallelWorkflowActions/' +
      workflowId +
      '/' +
      actionId +
      '/byWorkflowIdActionId',
    );
  }

  createWorkflowOosActions(parallelWorkflowActionsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oosParallelWorkflowActions',
      parallelWorkflowActionsData,
    );
  }

  updateWorkflowOosActions(parallelWorkflowActionsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oosParallelWorkflowActions',
      parallelWorkflowActionsData,
    );
  }

  deleteWorkflowOosActions(parallelWorkflowActionsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: parallelWorkflowActionsData,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/oosParallelWorkflowActions',
      httpOptions,
    );
  }

  //parallelWorkflowFindings
  getFindingsWorkflowByWorkflowIdFindingId(workflowId: any, findingId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/parallelWorkflowFindings/' +
      workflowId +
      '/' +
      findingId +
      '/byFindingsWorkflowIdFindingId',
    );
  }

  createParallelWorkflowFindings(parallelWorkflowFindingsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/parallelWorkflowFindings',
      parallelWorkflowFindingsData,
    );
  }

  updateParallelWorkflowFindings(parallelWorkflowFindingsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/parallelWorkflowFindings',
      parallelWorkflowFindingsData,
    );
  }

  deleteParallelWorkflowFindings(parallelWorkflowFindingsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: parallelWorkflowFindingsData,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/parallelWorkflowFindings',
      httpOptions,
    );
  }

  getoneQmsFinalNoGenerationStageOptionsVw(module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsFinalNoGenerationStageOptionsVw/' +
      module +
      '/byModule',
    );
  }
  getoneQmsskipstageOptionsVw(module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsFinalNoGenerationStageOptionsVw/' +
      module +
      '/skipstage',
    );
  }

  getQmsGroupDetailsByGroupId(groupId: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsGroupDetails/' + groupId + '/byGroupId');
  }

  getQmsGroupDetailsByGroupDetailId(groupId: any, groupDetailId: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsGroupDetails/' + groupId + '/' + groupDetailId + '/byGroupDetailId');
  }

  getQmsGroupDetailsByModule(groupId: any, module: any,) {
    return this.http.get(`${this.baseUrl}` + '/qmsGroupDetails/' + groupId + '/' + module + '/byModule');
  }

  createQmsGroupDetail(qmsGroupsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsGroupDetails',
      qmsGroupsData,
    );
  }

  updateQmsGroupDetail(qmsGroupsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsGroupDetails',
      qmsGroupsData,
    );
  }

  deleteQmsGroupDetail(qmsGroupsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: qmsGroupsData,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/qmsGroupDetails',
      httpOptions,
    );
  }

  activeInactiveQmsGroupDetail(qmsGroup: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsGroupDetails/activeInactive', qmsGroup);
  }

  copyQmsGroupDetails(qmsGroup: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsGroupDetails/copyGroupDetail', qmsGroup);
  }

  createOneQmsSwitchUserLog(qmsGroupsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsSwitchUserLogVw',
      qmsGroupsData,
    );
  }

  getOneQmsSwitchUserLogVw(module: any, groupId: any, refNo: any) {
    return this.http.get(`${this.baseUrl}/oneQmsSwitchUserLogVw/${module}/${groupId}/${refNo}/details`);
  }

  getOneQmsSwitchUserLogVwModule(module: any) {
    return this.http.get(`${this.baseUrl}/oneQmsSwitchUserLogVw/${module}/moduleLogs`);
  }

  //ActiveGroupUsers
  getQmsActiveGroupUsers(groupId: any, module: any, role: any,) {
    return this.http.get(`${this.baseUrl}` + '/qmsActiveGroupUsers/' + groupId + '/' + module + '/' + role + "/byGrpIdModuleQmsRoles");
  }

  getQmsUsersByModuleAndRoles(module: any, role: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsActiveGroupUsers/' + module + '/' + role + "/byModuleAndRole");
  }

  getQmsActiveUserByGroupIdModuleUserId(groupId: any, module: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsActiveGroupUsers/' + groupId + '/' + module + '/byGrpIdModuleUserId');
  }

  getQmsActiveUsersByGroupIdModule(groupId: any, module: any,) {
    return this.http.get(`${this.baseUrl}` + '/qmsActiveGroupUsers/' + groupId + '/' + module + "/byGrpIdModule");
  }

  getQmsGroupTopicUsers(groupId: any, module: any, userName: any,) {
    return this.http.get(`${this.baseUrl}` + '/qmsActiveGroupUsers/' + groupId + '/' + module + '/' + userName + "/forTopics");
  }

  getQmsGroupUsersVwByGroupDetailId(groupDetailId: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGroupUsers/" + groupDetailId + "/byGroupDetailId");
  }

  getQmsGroupUsersVwByUserId(groupDetailId: any, selectedUserId: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGroupUsers/" + groupDetailId + "/" + selectedUserId + "/byGroupIdUserId");
  }

  getQmsGroupUsersByRole(groupId: any, role: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGroupUsers/" + groupId + "/" + role + "/byQmsRole");
  }

  qmsGroupUserActiveInactive(qmsGroupUserActiveInactiveData: any) {
    return this.http.post(`${this.baseUrl}` + "/qmsGroupUsers/inActiveProcedure", qmsGroupUserActiveInactiveData);
  }

  createQmsGroupUsers(qmsGroupsData: any) {
    return this.http.post(`${this.baseUrl}` + "/qmsGroupUsers", qmsGroupsData);
  }

  updateQmsGroupUsers(qmsGroupsData: any) {
    return this.http.put(`${this.baseUrl}` + "/qmsGroupUsers", qmsGroupsData);
  }

  deleteQmsGroupUsers(qmsGroupsData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: qmsGroupsData,
    };
    return this.http.delete(`${this.baseUrl}` + "/qmsGroupUsers", httpOptions);
  }

  validateFile(fileName: string, fileFor: string, module: string) {
    return this.http.get(
      `${this.baseUrl}` +
      '/training/' +
      fileName +
      '/' +
      fileFor +
      '/' +
      module +
      '/validate',
    );
  }

  getContentsList(trainingId: number, version: number) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingContents/' +
      trainingId +
      '/' +
      version +
      '/byTrainingIdVersion',
    );
  }

  getContentsListForLaunch(
    trainingId: number,
    version: number,
    userTrainingId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingContents/' +
      trainingId +
      '/' +
      version +
      '/' +
      userTrainingId +
      '/forLaunch',
    );
  }

  getContentByContentId(contentId: number, trainingId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingContents/' +
      contentId +
      '/' +
      trainingId +
      '/' +
      version +
      '/conIdTrnIdVer',
    );
  }

  addOrUpdateTrainingContent(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/trainingContents',
      multipartData,
    );
  }

  reorderTrainingContent(data: any) {
    return this.http.put(`${this.baseUrl}` + '/trainingContents', data);
  }

  deleteTrainingContent(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/trainingContents',
      httpOptions,
    );
  }

  getContentsBasedOnDocId(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/trainingContents/forDocumentPublish',
      data,
    );
  }

  getContentAssessmentList(
    trainingId: number,
    version: number,
    contentId: number,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingQuestions/' +
      trainingId +
      '/' +
      version +
      '/' +
      contentId +
      '/byTrainingIdContentIdVersion',
    );
  }

  addOrUpdateContentQuestion(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/trainingQuestions',
      multipartData,
    );
  }

  reorderContentQuestion(data: any) {
    return this.http.put(`${this.baseUrl}` + '/trainingQuestions', data);
  }

  deleteContentQuestion(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/trainingQuestions',
      httpOptions,
    );
  }

  addQuestionsThroughFileUpload(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/trainingQuestions/bulkUpload',
      data,
    );
  }

  getQuestionOptionsList(
    trainingId: number,
    version: number,
    contentId: number,
    questionId: number,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingQuestionOptions/' +
      trainingId +
      '/' +
      version +
      '/' +
      contentId +
      '/' +
      questionId +
      '/byTrVrCoQuId',
    );
  }

  addOrUpdateQuestionOption(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/trainingQuestionOptions',
      multipartData,
    );
  }

  deleteQuestionOption(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/trainingQuestionOptions',
      httpOptions,
    );
  }

  getButtonLabels(trainingId: number, version: number, status: string) {
    return this.http.get(
      `${this.baseUrl}` +
      '/training/' +
      trainingId +
      '/' +
      version +
      '/' +
      status +
      '/getButtons',
    );
  }

  userPrivsDetails(userId: any) {
    return this.http.get(`${this.baseUrl}/userPrivs/${userId}/userPrivsDetails`);
  }

  getListOfQAUsersInUserPrivsList() {
    return this.http.get(`${this.baseUrl}/userPrivs/getListOfQaUsers`);
  }
  getTmsQAUserList() {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsUsersWithRolesVw/tmsQAUser',
    );
  }

  createuserpriv(userPrivDetails: any) {
    return this.http.post(`${this.baseUrl}` + '/userPrivs', userPrivDetails);
  }

  updateuserpriv(userPrivDetails: any) {
    return this.http.put(`${this.baseUrl}` + '/userPrivs', userPrivDetails);
  }

  nonorgModules() {
    return this.http.get(
      `${this.baseUrl}` +
      '/nonorgModules/nonorgModulesDetails'
    );
  }
  nonorgModuleprivs() {
    return this.http.get(
      `${this.baseUrl}` +
      '/nonorgModules/nonorgModuleprivsDetails');
  }
  getTaskStages(trainingId: number, version: number) {
    return this.http.get(
      `${this.baseUrl}` + '/taskStages/' + trainingId + '/' + version + '/list',
    );
  }

  getTaskStagesForFindings(trainingId: number, version: number) {
    return this.http.get<any[]>(
      `${this.baseUrl}` +
      '/taskStages/' +
      trainingId +
      '/' +
      version +
      '/list',
    );
  }

  updateTaskStage(data: any) {
    return this.http.put(`${this.baseUrl}` + '/taskStages', data);
  }

  getModuleStages(module: string, stageName: string) {
    return this.http.get(`${this.baseUrl}` + "/moduleStages/" + module + "/" + stageName + "/byModuleStageName");
  }

  getTaskStageUsers(refNo: number, version: number, stageName: string,) {
    return this.http.get(`${this.baseUrl}` + '/taskStageUsers/' + refNo + '/' + version + '/' + stageName + "/byRefNoVersionStageName");
  }

  getRoleOfUserForSignoff(refNo: number, version: number, stageName: string) {
    return this.http.get(`${this.baseUrl}` + '/taskStageUsers/' + refNo + '/' + version + '/' + stageName + '/byRefNoVersionStageNameUserId');
  }

  addTaskStageUser(data: any) {
    return this.http.post(`${this.baseUrl}` + '/taskStageUsers', data);
  }

  updateTaskStageUser(data: any) {
    return this.http.put(`${this.baseUrl}` + '/taskStageUsers', data);
  }

  deleteTaskStageUser(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(`${this.baseUrl}` + '/taskStageUsers', httpOptions);
  }

  addTaskStageCollaborative(data: any) {
    return this.http.post(`${this.baseUrl}` + '/taskStageUsers/collaborative', data);
  }

  getUsersListForStageUsers(category: any) {
    return this.http.get(
      `${this.baseUrl}` + '/training/' + category + '/byCategory',
    );
  }

  performButtonOperation(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/training/performOperation',
      multipartData,
    );
  }

  getAllReasonForSignTemplates() {
    return this.http.get(`${this.baseUrl}` + '/reasonForSignTemplate/getAllTemplates');
  }

  getReasonForSignByTemplateId(templateId: any,) {
    return this.http.get(`${this.baseUrl}` + '/reasonForSignTemplate/' + templateId + '/byTemplateId');
  }

  getReasonForSigns(reasonForSign: any) {
    return this.http.post(`${this.baseUrl}` + '/reasonForSignTemplate/reasonForSigns', reasonForSign);
  }

  getReasonForSignsByRole(reasonForSign: any) {
    return this.http.post(`${this.baseUrl}` + '/reasonForSignTemplate/reasonForSignsByRole', reasonForSign);
  }

  getReasonForSignsForBti(reasonForSign: any) {
    return this.http.post(`${this.baseUrl}` + '/reasonForSignTemplate/reasonForSignsForBti', reasonForSign);
  }

  getReasonForSignsForBtiByRole(reasonForSign: any) {
    return this.http.post(`${this.baseUrl}` + '/reasonForSignTemplate/reasonForSignsForBtiByRole', reasonForSign);
  }

  getDistinctModuleStageName(module: any,) {
    return this.http.get(`${this.baseUrl}` + '/reasonForSignTemplate/' + module + '/byModule');
  }

  getReasonForSignOptionsByModuleStageName(module: any, stageName: any,) {
    return this.http.get(`${this.baseUrl}` + '/reasonForSignTemplate/' + module + '/' + stageName + '/byModuleStageName');
  }

  createReasonForSignature(reasonForSign: any) {
    return this.http.post(`${this.baseUrl}` + '/reasonForSignTemplate', reasonForSign);
  }

  updateReasonForSignature(reasonForSign: any) {
    return this.http.put(`${this.baseUrl}` + '/reasonForSignTemplate', reasonForSign);
  }

  deleteReasonForSignature(reasonForSign: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(reasonForSign),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/reasonForSignTemplate',
      httpOptions1,
    );
  }

  getfirstmenu() {
    return this.http.get(`${this.baseUrl}` + "/menuUser/leftmenu");
  }

  getNonOrgCodeListsByGroupName(groupName: string) {
    return this.http.get(`${this.baseUrl}` + "/nonorgCodeLists/" + groupName + "/byGroupName");

  }

  //Timezone CodeList
  getTimezoneListDetails() {
    return this.http.get(`${this.baseUrl}` + '/timezones/getTinmezoneList');
  }

  // OneQmsUsersVw
  getOneQmsUsersVwDetails(
    searchOneQmsUserVwDetails: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/usersVw/getOneQmsUsersVwDetails',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  getOneQmsAllUsersVwDetails(
    searchOneQmsUserVwDetails: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/usersVw/getOneQmsAllUsersVwDetails',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }
  // OneQmsUsersVw
  getOneQmsUsersVwDetailsByManagerId(
    searchOneQmsUserVwDetails: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/usersVw/getOneQmsUsersVwDetailsWithManagerId',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  //FlexiField Setup

  getFlexifieldSetupByModuleList(module: any, group: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/flexifieldsSetup/' +
      module +
      '/' +
      group +
      '/byModuleAndGroup',
    );
  }

  getFlexifieldSetupById(fieldId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/flexifieldsSetup/' + fieldId + '/byfieldId',
    );
  }

  createFlexifieldSetup(flexibleFields: any) {
    return this.http.post(
      `${this.baseUrl}` + '/flexifieldsSetup',
      flexibleFields,
    );
  }

  updateFlexifieldSetup(flexibleFields: any) {
    return this.http.put(
      `${this.baseUrl}` + '/flexifieldsSetup',
      flexibleFields,
    );
  }

  deleteFlexifieldSetup(flexibleFields: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(flexibleFields),
    };
    return this.http.delete<dmsSettingsInterface>(
      this.baseUrl + '/flexifieldsSetup',
      httpOptions1,
    );
  }

  getQmsSettingVw() {
    return this.http.get(`${this.baseUrl}` + '/qmsSettingsVw/getAll');
  }

  createQmsSettings(data: any): Observable<qmsSettingsInterface> {
    return this.http
      .post<qmsSettingsInterface>(
        this.baseUrl + '/qmsSettings',
        JSON.stringify(data),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  updateQmsSettings(data: any): Observable<qmsSettingsInterface> {
    return this.http
      .put<qmsSettingsInterface>(
        this.baseUrl + '/qmsSettings',
        JSON.stringify(data),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  deleteQmsSettings(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http
      .delete<qmsSettingsInterface>(this.baseUrl + '/qmsSettings', httpOptions1)
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  getDmsSettingVw() {
    return this.http.get(`${this.baseUrl}` + '/dmsSettingsVw/All');
  }

  createDmsSettings(data: any): Observable<dmsSettingsInterface> {
    return this.http
      .post<dmsSettingsInterface>(
        this.baseUrl + '/dmsSettings',
        JSON.stringify(data),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  updateDmsSettings(data: any): Observable<dmsSettingsInterface> {
    return this.http
      .put<dmsSettingsInterface>(
        this.baseUrl + '/dmsSettings',
        JSON.stringify(data),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  deleteDmsSettings(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http
      .delete<dmsSettingsInterface>(this.baseUrl + '/dmsSettings', httpOptions1)
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  getDataTypeForMappingColumn(dataType: string) {
    return this.http.get(
      `${this.baseUrl}` + '/flexifieldsSetup/' + dataType + '/getDataType',
    );
  }

  getAllOrgReportImages() {
    return this.http.get(`${this.baseUrl}` + '/orgImages/getAllOrgImages');
  }

  getReportImagesBySelectedOrganization(selectedOrgId: any) {
    return this.http.get(`${this.baseUrl}` + '/orgImages/' + selectedOrgId + "/byOrgId");
  }

  addLogoImage(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/orgImages', addLogoData);
  }

  updateLogoImage(uploadLogoData: any) {
    return this.http.put(`${this.baseUrl}` + '/orgImages', uploadLogoData);
  }

  genRateCrReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/crRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }
  genRateINReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/inRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }
  genRateCAPAReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/capaRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  genRateAUReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/auRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  genRateAUScheduleReport(addLogoData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/pdf/auScheduleReport',
      addLogoData,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  genRateAUFindingReport(addLogoData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/pdf/auFindingReport',
      addLogoData,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  genRateAUPlanReport(addLogoData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/pdf/auPlanRepost',
      addLogoData,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }
  genRateDVReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/dvRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  genRateCCReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/ccRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }
  genRateOOSReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/OOSRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }
  genRateQIReport(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/qiRepost', addLogoData, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  getDocumentsToView(contentId: any, trainingId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingContents/' +
      contentId +
      '/' +
      trainingId +
      '/' +
      version +
      '/contentToView',
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  getDocumentsToViewForLaunch(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/trainingContents/contentForLaunch',
      data,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  getDocumentTemplateToView(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocumentTemplateVw/' +
      templateId +
      '/templateToView',
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  downloadDocumentTemplate(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocumentTemplateVw/downloadTemplate',
      data,
    );
  }

  downloadOriginalDocument(data: any, filename: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/documentDownloadOriginal',
      data,
    );
  }

  getDocumentToViewAudit(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/documnetcall',
      data,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  getClobToViewAudit(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/loadClobData',
      data,
    );
  }

  getClobToViewOverAllAction(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/loadClobDataOverAllAction',
      data,
    );
  }

  getClobToViewDistributed(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/loadClobDataDistributed',
      data,
    );
  }

  //OneQmsUserDetails
  getOneQmsUserDetails() {
    return this.http.get(`${this.baseUrl}` + '/userDetails');
  }

  addUserImage(addLogoData: any) {
    return this.http.post(`${this.baseUrl}` + '/userDetails', addLogoData);
  }

  updateUserImage(uploadLogoData: any) {
    return this.http.put(`${this.baseUrl}` + '/userDetails', uploadLogoData);
  }

  //DMS Groups
  getDmsGroupsVwDetails() {
    return this.http.get(`${this.baseUrl}` + '/dmsGroupsVw/All');
  }

  getDmsGroupsVwDetailsByGroupId(groupId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsGroupsVw/' + groupId + '/getByGroupId',
    );
  }

  getUserGroupsForFolders(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsGroupsVw/' + folderId + '/getByGroups',
    );
  }

  createDmsGruoups(dmsGroupsData: any) {
    return this.http.post(`${this.baseUrl}` + '/dmsGroups', dmsGroupsData);
  }

  updateDmsGroups(dmsGroupsData: any) {
    return this.http.put(`${this.baseUrl}` + '/dmsGroups', dmsGroupsData);
  }

  deleteDmsGroups(dmsGroupsFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(dmsGroupsFieldData),
    };
    return this.http.delete<dmsSettingsInterface>(
      this.baseUrl + '/dmsGroups',
      httpOptions1,
    );
  }

  //DMS Group Users
  getDmsUserRolesVwDetails() {
    return this.http.get(`${this.baseUrl}` + '/dmsUserRolesVw/All');
  }

  getOneQmsUsersWithRolesVwDetails(groupName: any) {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsUsersWithRolesVw/' + groupName + '/byModule',
    );
  }

  // getDmsGroupUsersDetailsByGroupId( groupId: any) {
  //   return this.http.get(`${this.baseUrl}` + "/dmsGroupUsers/" +  groupId + "/getByGroupId");
  // }
  getDmsGroupUsersDetailsByGroupUserId(groupUserId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsGroupUsers/' + groupUserId + '/getByGroupUserId',
    );
  }
  createDmsGruoupUsers(dmsGroupUsersData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsGroupUsers',
      dmsGroupUsersData,
    );
  }

  updateDmsGroupUsers(dmsGroupUsersData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsGroupUsers',
      dmsGroupUsersData,
    );
  }

  deleteDmsGroupUsers(dmsGroupsFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(dmsGroupsFieldData),
    };
    return this.http.delete<dmsSettingsInterface>(
      this.baseUrl + '/dmsGroupUsers',
      httpOptions1,
    );
  }

  //DMS Group Folders
  getDmsGroupFoldersDetailsByGroupId(groupId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsGroupFolders/' + groupId + '/getByGroupId',
    );
  }

  createDmsGruoupFolders(dmsGroupUsersData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsGroupFolders',
      dmsGroupUsersData,
    );
  }

  updateDmsGroupFolders(dmsGroupUsersData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsGroupFolders',
      dmsGroupUsersData,
    );
  }

  deleteDmsGroupFolders(dmsGroupUsersData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(dmsGroupUsersData),
    };
    return this.http.delete<dmsSettingsInterface>(
      this.baseUrl + '/dmsGroupFolders',
      httpOptions1,
    );
  }

  //Tms Training Parameter Template
  getTmsTrainingParameterTemplateVwDetails() {
    return this.http.get(
      `${this.baseUrl}` + '/tmsTrainingParameterTemplateVw/getAllTemplates',
    );
  }

  getTmsTrainingParameterTemplateVwDetailsByTemplateId(templateId: any) {
    return this.http.get(`${this.baseUrl}` + '/tmsTrainingParameterTemplateVw/' + templateId + '/byTemplateId');
  }

  createTmsTrainingParameterTemplate(trainingParameterTemplateFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/tmsTrainingParameterTemplateVw',
      trainingParameterTemplateFieldData,
    );
  }

  updateTmsTrainingParameterTemplate(trainingParameterTemplateFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/tmsTrainingParameterTemplateVw',
      trainingParameterTemplateFieldData,
    );
  }

  deleteTmsTrainingParameterTemplate(deleteTrainingParameterTemplateData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(deleteTrainingParameterTemplateData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/tmsTrainingParameterTemplateVw',
      httpOptions1,
    );
  }

  getAllDownloadTemplates() {
    return this.http.get<any[]>(
      `${this.baseUrl}/dmsDocumentDownloadTemplateVw/getAllDownloadTemplates`,
    );
  }

  getDmsDocumentDownloadTemplateVwDetailsByTemplateId(templateId: any) {
    return this.http.get(`${this.baseUrl}/dmsDocumentDownloadTemplateVw/${templateId}/getByTemplateId`);
  }

  createDmsDocumentDownloadTemplate(documentDownloadTemplateFieldData: any) {
    return this.http.post(
      `${this.baseUrl}/dmsDocumentDownloadTemplateVw`,
      documentDownloadTemplateFieldData,
    );
  }

  updateDmsDocumentDownloadTemplate(documentDownloadTemplateFieldData: any) {
    return this.http.put(
      `${this.baseUrl}/dmsDocumentDownloadTemplateVw`,
      documentDownloadTemplateFieldData,
    );
  }

  deleteDmsDocumentDownloadTemplate(deleteDocumentDownloadTemplateData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(deleteDocumentDownloadTemplateData),
    };

    return this.http.delete<any>(
      `${this.baseUrl}/dmsDocumentDownloadTemplateVw`,
      httpOptions,
    );
  }

  //DMS Document Template
  getDmsDocumentTemplateVwDetails() {
    return this.http.get(`${this.baseUrl}` + '/dmsDocumentTemplateVw/All');
  }

  getDmsDocumentTemplateVwDetailsByTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocumentTemplateVw/' +
      templateId +
      '/getByTemplateId',
    );
  }

  getDocumentTemplateByFolderId(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocumentTemplateVw/' +
      folderId +
      '/getTemplateByFolder',
    );
  }

  createDmsDocumentTemplate(documentTemplateFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocumentTemplateVw',
      documentTemplateFieldData,
    );
  }

  updateDmsDocumentTemplate(documentTemplateFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocumentTemplateVw',
      documentTemplateFieldData,
    );
  }

  deleteDmsDocumentTemplate(documentTemplateFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(documentTemplateFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/dmsDocumentTemplateVw',
      httpOptions1,
    );
  }

  //Lms Training Review Period
  getLmsTrainingReviewPeriodVwDetails() {
    return this.http.get(`${this.baseUrl}` + '/lmsTrainingReviewPeriodVw/All');
  }

  getLmsTrainingReviewPeriodVwDetailsByReviewPeriodId(reviewPeriodId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/lmsTrainingReviewPeriodVw/' +
      reviewPeriodId +
      '/getByReviewPeriodId',
    );
  }

  createLmsTrainingReviewPeriod(trainingReviewPeriodFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/lmsTrainingReviewPeriodVw',
      trainingReviewPeriodFieldData,
    );
  }

  updateLmsTrainingReviewPeriod(trainingReviewPeriodFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/lmsTrainingReviewPeriodVw',
      trainingReviewPeriodFieldData,
    );
  }

  deleteLmsTrainingReviewPeriod(trainingReviewPeriodFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(trainingReviewPeriodFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/lmsTrainingReviewPeriodVw',
      httpOptions1,
    );
  }

  //Qms Product Master
  getQmsProductMasterVwDetails() {
    return this.http.get(
      `${this.baseUrl}` + '/qmsProductMasterVw/getAllProducts',
    );
  }

  getQmsProductMasterVwDetailsByProductId(productId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsProductMasterVw/' + productId + '/byProductId',
    );
  }

  createQmsProductMaster(productMasterFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsProductMasterVw',
      productMasterFieldData,
    );
  }

  updateQmsProductMaster(productMasterFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsProductMasterVw',
      productMasterFieldData,
    );
  }

  deleteQmsProductMaster(productMasterFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(productMasterFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsProductMasterVw',
      httpOptions1,
    );
  }

  //Qms Product Countries
  getQmsProductCountriesVwDetails() {
    return this.http.get(
      `${this.baseUrl}` + '/qmsProductCountriesVw/getAllProductCountries',
    );
  }

  getQmsProductCountriesVwDetailsByProductCountryId(productCountryId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsProductCountriesVw/' +
      productCountryId +
      '/byProductCountryId',
    );
  }

  getProductCountriesDetailsByProductId(productId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsProductCountriesVw/' +
      productId +
      '/byProductId',
    );
  }

  getCountryLocationsByProductIdAndCountryCode(
    productId: any,
    authorizationCountry: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsProductCountriesVw/' +
      productId +
      '/' +
      authorizationCountry +
      '/byCountry',
    );
  }

  createQmsProductCountries(productCountriesFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsProductCountriesVw',
      productCountriesFieldData,
    );
  }

  updateQmsProductCountries(productCountriesFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsProductCountriesVw',
      productCountriesFieldData,
    );
  }

  deleteQmsProductCountries(productCountriesFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(productCountriesFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsProductCountriesVw',
      httpOptions1,
    );
  }

  //Qms Vendors
  getQmsVendorsVwDetails() {
    return this.http.get(`${this.baseUrl}` + '/qmsVendorsVw/getAllVendors');
  }

  getQmsVendorsVwDetailsByVendorId(vendorId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsVendorsVw/' + vendorId + '/byVendorId',
    );
  }

  fetchVendorListWithSearchCriteria(searchedVendorData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsVendorsVw/searchVendor',
      searchedVendorData,
    );
  }

  createQmsVendorsDetails(vendorsFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsVendorsVw',
      vendorsFieldData,
    );
  }

  updateQmsVendorsDetails(vendorsFieldData: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsVendorsVw', vendorsFieldData);
  }

  deleteQmsVendorsDetails(deleteQmsVendorsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(deleteQmsVendorsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsVendorsVw',
      httpOptions1,
    );
  }

  getTrainingsRepCount() {
    return this.http.get(
      `${this.baseUrl}` + '/userTrainingsCountRepVw/All',
    );
  }

  getTrainingListByStatusforRep(status: any) {
    return this.http.get(`${this.baseUrl}` + '/userTrainings/' + status + '/byUserStatus');
  }

  setTrainingDetails(categoryDetails: any, trainingData: any) {
    this.categoriesList = categoryDetails;
    this.trainingData = trainingData;
  }

  getCategoryData() {
    return this.categoriesList;
  }

  getTrainingData() {
    return this.trainingData;
  }

  getTrainingContentsForLaunch(trainingId: any) {
    return this.http.get(`${this.baseUrl}` + '/userTrainingContents/' + trainingId);
  }

  // Task Grid Chart Count
  getGridChartCountsDetails(chartDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getGridChartCounts',
      chartDetails,
    );
  }
  getSchuduleTrainingGridChartCountsDetails(chartDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getGridChartCountsSchduleTraining',
      chartDetails,
    );
  }
  // Task Grid Chart Data by Status
  getGridDataDetailsByChartStatus(status: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getGridDataDetailsByChartStatus',
      status,
    );
  }

  // QMS CR
  getCrByCrNo(crNo: any) {
    return this.http.get(`${this.baseUrl}` + '/cr/' + crNo);
  }

  createCr(cr: any) {
    return this.http.post(`${this.baseUrl}` + '/cr', cr);
  }

  updateCr(cr: any) {
    return this.http.put(`${this.baseUrl}` + '/cr', cr);
  }

  getQmsButtons(obj: any) {
    return this.http.post(`${this.baseUrl}` + '/cr/getButtons', obj);
  }

  performQualityBtnOperation(multipartData: any) {
    return this.http.post(`${this.baseUrl}` + '/cr/performOperation', multipartData,);
  }

  getOosByOosNo(oosNo: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsOos/' + oosNo + '/byOosNo');
  }

  createOos(oos: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsOos', oos);
  }

  updateOos(oos: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsOos', oos);
  }

  getQmsActionByRefNo(refNo: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsActions/' + refNo + "/byRefNo");
  }

  getQmsActionsByActionId(actionId: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsActions/' + actionId + "/byActionId");
  }

  createQmsAction(action: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsActions', action);
  }

  updateQmsAction(action: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsActions', action);
  }

  getActionButtons(action: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsActions/getActionButtons', action);
  }

  performActionsAction(action: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsActions/performAction', action);
  }

  deleteQmsAction(action: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: action,
    };
    return this.http.delete(`${this.baseUrl}` + '/qmsActions', httpOptions);
  }

  getAllPreActionByRefNo(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/preAction/' + refNo + '/byRefNo',
    );
  }

  getPreActionById(actionId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/preAction/' + actionId + '/byActionId',
    );
  }

  createPreAction(preAction: any) {
    return this.http.post(`${this.baseUrl}` + '/preAction', preAction);
  }

  updatePreAction(preAction: any) {
    return this.http.put(`${this.baseUrl}` + '/preAction', preAction);
  }

  deletePreAction(preAction: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: preAction,
    };
    return this.http.delete(`${this.baseUrl}` + '/preAction', httpOptions);
  }

  getPreActionButtons(preAction: any) {
    return this.http.post(
      `${this.baseUrl}` + '/preAction/getActionButtons',
      preAction,
    );
  }

  performPreAction(preAction: any) {
    return this.http.post(
      `${this.baseUrl}` + '/preAction/performAction',
      preAction,
    );
  }

  getAllOosActionsByRefNo(oosNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/oosActions/' + oosNo + '/byOssNo',
    );
  }

  getOosActionsByActionId(actionId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/oosActions/' + actionId + '/byActionId',
    );
  }

  createOosActions(oosAction: any) {
    return this.http.post(`${this.baseUrl}` + '/oosActions', oosAction);
  }

  updateOosActions(oosAction: any) {
    return this.http.put(`${this.baseUrl}` + '/oosActions', oosAction);
  }

  deleteOosActions(oosAction: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: oosAction,
    };
    return this.http.delete(`${this.baseUrl}` + '/oosActions', httpOptions);
  }

  getOosActionButtons(oosAction: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oosActions/getActionButtons',
      oosAction,
    );
  }

  performOosActionsAction(oosAction: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oosActions/performAction',
      oosAction,
    );
  }

  // OneQmsNonorgModuleStages
  getOneQmsNonorgModuleStagesDetailsByOrgId() {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsNonorgModuleStages/All'
    );
  }

  getOneQmsNonorgModuleStagesDetails(module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsNonorgModuleStages/' +
      module + '/bymodule'
    );
  }


  // TmsSettings
  getTmsSettingsVwDetails() {
    return this.http.get(
      `${this.baseUrl}` + '/tmsSettingsVw/getAllTmsSettings',
    );
  }

  createTmsSettingsDetails(tmsSettingsObj: any) {
    return this.http.post(`${this.baseUrl}` + '/tmsSettings', tmsSettingsObj);
  }

  updateTmsSettingsDetails(tmsSettingsObj: any) {
    return this.http.put(`${this.baseUrl}` + '/tmsSettings', tmsSettingsObj);
  }

  deleteTmsSettingsDetails(tmsSettingsObj: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(tmsSettingsObj),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/tmsSettings',
      httpOptions1,
    );
  }

  /* Multi Organization */
  getTmsGroupsVwDetails(orgId?: any) {
    return this.http.get(`${this.baseUrl}/tmsGroups/getTmsGroupsFrmTable`, {
      params: { ...(orgId != null && { orgId: orgId }) },
    });
  }

  getTmsGroupsVwDetailsFromView() {
    return this.http.get(`${this.baseUrl}` + '/tmsGroups/getTmsGroupsFrmVw');
  }

  getTrainingListForReport(whereVal: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsTrainingGrouplistRepVw/' +
      whereVal +
      '/groupListReport',
    );
  }

  getTrainingListForReportFroDynamic(whereVal: any, searchVal: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsTrainingGrouplistRepVw/' +
      whereVal +
      '/' +
      searchVal +
      '/dynamicGroupListReport',
    );
  }
  getTrainingListForReportFroDynamicHedding(whereVal: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsTrainingGrouplistRepVw/' +
      whereVal +
      '/dynamicHeading',
    );
  }

  getExpiryDateTrainingListForReport(whereVal: any, typeDue: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/training/' +
      whereVal +
      '/' +
      typeDue +
      '/expiryReport',
    );
  }

  createTmsGroup(data: any) {
    return this.http.post(`${this.baseUrl}` + '/tmsGroups', data);
  }

  updateTmsGroup(data: any) {
    return this.http.put(`${this.baseUrl}` + '/tmsGroups', data);
  }

  deleteTmsGroup(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/tmsGroups',
      httpOptions1,
    );
  }

  //Tms Training Groups

  createTmsGroupUser(data: any) {
    return this.http.post(`${this.baseUrl}` + '/tmsGroupUsers', data);
  }

  deleteTmsGroupUser(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/tmsGroupUsers',
      httpOptions1,
    );
  }

  getTrainingsUsersList(
    searchOneQmsUserVwDetails: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/userPrivs/searchUser',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  //Tms Training Groups
  getTmsGroupTrainingDetail(groupTrainingId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsGroupTrainings/' +
      groupTrainingId +
      '/byGroupTrainingId',
    );
  }

  createTmsGroupTraining(data: any) {
    return this.http.post(`${this.baseUrl}` + '/tmsGroupTrainings', data);
  }

  updateTmsGroupTraining(data: any) {
    return this.http.put(`${this.baseUrl}` + '/tmsGroupTrainings', data);
  }

  deleteTmsGroupTraining(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/tmsGroupTrainings',
      httpOptions1,
    );
  }

  searchTrainingsByCondition(searchData: any): Observable<any> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/training/searchTrainings',
        JSON.stringify(searchData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  searchTrainingsByConditionForScheduler(searchData: any): Observable<any> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/training/searchTrainingsForSchedules',
        JSON.stringify(searchData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  searchTrainingsByConditionFromGroups(searchData: any): Observable<any> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/tmsGroupTrainings/searchTrainings',
        JSON.stringify(searchData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  searchTmsGroups(searchData: any): Observable<any> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/tmsGroups/searchTrainingGroups',
        JSON.stringify(searchData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  getQmsReportTemplateVwDetails() {
    return this.http.get(
      `${this.baseUrl}` + '/qmsReportTemplateVw/getAllReportTemplates',
    );
  }

  getQmsReportTemplateDetailsByOrgIdAndTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsReportTemplateVw/' +
      templateId +
      '/byTemplateId',
    );
  }

  getQmsReportTemplateDetailsByModule(module: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsReportTemplateVw/' + module + '/byModule',
    );
  }

  getQmsReportTemplateDetailsByModuleAndGroupId(module: any, groupId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsReportTemplateVw/' +
      module + "/" +
      groupId +
      '/byModuleGroupId',
    );
  }

  createQmsReportTemplateVwDetails(qmsReportTemplateFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsReportTemplateVw',
      qmsReportTemplateFieldData,
    );
  }

  updateQmsReportTemplateVwDetails(qmsReportTemplateFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsReportTemplateVw',
      qmsReportTemplateFieldData,
    );
  }

  deleteQmsReportTemplateVwDetails(qmsReportTemplateFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsReportTemplateFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsReportTemplateVw',
      httpOptions1,
    );
  }

  // Dms Folders
  getDmsFoldersDetails() {
    return this.http.get(`${this.baseUrl}` + '/dmsFolders/All');
  }

  searchFolderByFolderName(folderName: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsFoldersVw/' + folderName + '/search',
    );
  }

  getQmsReportTemplateSectionFieldVwDetails() {
    return this.http.get(
      `${this.baseUrl}` + '/qmsReportTemplateSectionFieldVw/getAllSections',
    );
  }

  getQmsReportTemplateSectionFieldsByOrgIdAndTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsReportTemplateSectionFieldVw/' +
      templateId +
      '/byTemplateId',
    );
  }

  getQmsReportTemplateSectionVwData(reportSectionOrFieldId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsReportTemplateSectionFieldVw/' +
      reportSectionOrFieldId +
      '/byIdSec',
    );
  }

  getQmsReportTemplateSectionFieldVwData(reportSectionOrFieldId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsReportTemplateSectionFieldVw/' +
      reportSectionOrFieldId +
      '/byIdSecFieId',
    );
  }

  createQmsReportTemplateSectionField(qmsReportTemplateFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsReportTemplateSectionFieldVw',
      qmsReportTemplateFieldData,
    );
  }

  updateQmsReportTemplateSectionField(qmsReportTemplateFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsReportTemplateSectionFieldVw',
      qmsReportTemplateFieldData,
    );
  }

  deleteQmsReportTemplateSectionField(qmsReportTemplateFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsReportTemplateFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsReportTemplateSectionFieldVw',
      httpOptions1,
    );
  }

  getQuestionnaireTemplateByOrgIdAndUserId() {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsQuestionnaireTemplate/getAllQuestionnaireTemplate',
    );
  }

  getQmsQuestionnaireTemplateDetailsByOrgIdAndTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsQuestionnaireTemplate/' +
      templateId +
      '/byTemplateId',
    );
  }

  createQmsQuestionnaireTemplate(qmsQuestionnaireTemplateFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsQuestionnaireTemplate',
      qmsQuestionnaireTemplateFieldData,
    );
  }

  updateQmsQuestionnaireTemplate(qmsQuestionnaireTemplateFieldData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsQuestionnaireTemplate',
      qmsQuestionnaireTemplateFieldData,
    );
  }

  deleteQmsQuestionnaireTemplate(qmsQuestionnaireTemplateFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsQuestionnaireTemplateFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsQuestionnaireTemplate',
      httpOptions1,
    );
  }

  getQmsQuestionnaireTemplateQuestionDetailsByOrgIdAndTemplateIdAndQuestionId(templateId: any, questionId: any,) {
    return this.http.get(`${this.baseUrl}` + '/qmsQuestionnaireTemplateQuestions/' + templateId + '/' + questionId + '/byTemplateQuestionId');
  }

  createQmsQuestionnaireTemplateQuestion(
    qmsQuestionnaireQuestionsFieldData: any,
  ) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsQuestionnaireTemplateQuestions',
      qmsQuestionnaireQuestionsFieldData,
    );
  }

  updateQmsQuestionnaireTemplateQuestion(
    qmsQuestionnaireQuestionsFieldData: any,
  ) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsQuestionnaireTemplateQuestions',
      qmsQuestionnaireQuestionsFieldData,
    );
  }

  deleteQmsQuestionnaireTemplateQuestion(
    qmsQuestionnaireQuestionsFieldData: any,
  ) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsQuestionnaireQuestionsFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsQuestionnaireTemplateQuestions',
      httpOptions1,
    );
  }

  trainingContentAction(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainings/trainingContentAction',
      data,
    );
  }

  trainingAssessmentAction(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingAssessment/trainingAsessmentAction',
      data,
    );
  }

  getQuestionListForLaunch(
    trainingId: number,
    version: number,
    contentId: number,
    userTrainingId: number,
    loaderskip: boolean,
  ) {
    let headers = new HttpHeaders();
    if (loaderskip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }
    return this.http.get(
      `${this.baseUrl}/trainingQuestions/${trainingId}/${version}/${contentId}/${userTrainingId}/forLaunch`,
      { headers },
    );
  }

  getQuestionListForLaunch1(
    trainingId: number,
    version: number,
    contentId: number,
    userTrainingId: number,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingQuestions/' +
      trainingId +
      '/' +
      version +
      '/' +
      contentId +
      '/' +
      userTrainingId +
      '/forLaunch1',
    );
  }

  getquestionDetailForLaunch(trainingId: any, contentId: number) {
    return this.http.get(
      `${this.baseUrl}` +
      '/userTrainingAssessment/' +
      trainingId +
      '/' +
      contentId +
      '/getAllAssessments',
    );
  }

  launchTraining(data: any) {
    return this.http.put(`${this.baseUrl}` + '/userTrainings/launch', data);
  }

  selfAssignTraining(data: any) {
    return this.http.put(`${this.baseUrl}` + '/userTrainings/selfAssign', data);
  }

  completeTraining(data: any) {
    return this.http.put(`${this.baseUrl}` + '/userTrainings/complete', data);
  }

  retakeAssessment(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingAssessment/retakeTraining',
      data,
    );
  }

  // QMS Task Documents
  getQmsTaskDocumentsVwDetailsByModule(module: any, refNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskDocumentsVw/' +
      module +
      '/' +
      refNo +
      '/byModuleRefNo',
    );
  }

  getQmsTaskDocumentsVwDetailsByauRefId(refNo: any, auRefId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskDocumentsVw/' +
      refNo +
      '/' +
      auRefId +
      '/byModuleRefNo',
    );
  }

  getQmsTaskDocumentsVwDetailsByDocumentId(refNo: any, documentId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskDocumentsVw/' +
      refNo +
      '/' +
      documentId +
      '/byRefNoDocId',
    );
  }

  createQmsTaskDocuments(qmsTaskDocumentsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskDocumentsVw',
      qmsTaskDocumentsData,
    );
  }

  updateQmsTaskDocuments(qmsTaskDocumentsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsTaskDocumentsVw',
      qmsTaskDocumentsData,
    );
  }

  deleteQmsTaskDocuments(qmsTaskDocumentsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsTaskDocumentsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskDocumentsVw',
      httpOptions1,
    );
  }

  getDependenciesListByRefNo(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsTaskDependenciesVw/' + refNo + '/byRefNo',
    );
  }

  createQmsTaskDependencies(qmsTaskDependenciesData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskDependenciesVw',
      qmsTaskDependenciesData,
    );
  }

  deleteQmsTaskDependencies(qmsTaskDependenciesData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsTaskDependenciesData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskDependenciesVw',
      httpOptions1,
    );
  }

  getUserTrainingsByTrainingId(userTrainingId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/userTrainingsVw/' +
      userTrainingId +
      '/byUserTrainingId',
    );
  }

  getUserTrainingByTrainingIdAndVersion(trainingId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/userTrainingsVw/' +
      trainingId +
      '/' +
      version +
      '/byTrainingIdAndVersion',
    );
  }

  getDocumentTypeListFromOneQmsDocumentTypesVw() {
    return this.http.get<any[]>(
      `${this.baseUrl}/oneQmsDocumentTypesVw/getDocumentTypeList`,
    );
  }
  getDocumentTypeByCode(docTypeCode: any) {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsDocumentTypesVw/' + docTypeCode + '/byCode',
    );
  }

  getDocumentTypeBasedOnModule(module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsDocumentTypesVw/' +
      module +
      '/typeBasedOnModule',
    );
  }
  getDocumentTypeBasedOnDocTypeId(docTypeId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsDocumentTypesVw/' +
      docTypeId +
      '/bydocumentTypeId',
    );
  }
  getDmsFolderList(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsFolders/' + parentFolderId + '/byparentFolderId',
    );
  }

  getUserCountForFolderAuth() {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsUsersWithRolesVw/countForFolder'
    );
  }

  createDmsFolder(data: any) {
    return this.http.post(`${this.baseUrl}` + '/dmsFolders', data);
  }

  updateDmsFolder(data: any) {
    return this.http.put(`${this.baseUrl}` + '/dmsFolders', data);
  }

  deleteDmsFolder(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/dmsFolders', httpOptions1);
  }

  setParentFolderId(number: any) {
    this.parentFolderId = number;
  }

  getParentFolderId() {
    return this.parentFolderId;
  }

  getDmsDocumentsList(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      parentFolderId +
      '/byparentFolderId',
    );
  }

  getDocumentByDocumentId(docId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      docId +
      '/' +
      version +
      '/bydocIdandversion',
    );
  }

  getDocumentByDocumentIdForDistFolder(

    docId: any,
    version: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      docId +
      '/' +
      version +
      '/byIdForDistDoc',
    );
  }

  getDocumentVersionByDocId(docId: any) {
    return this.http.get(`${this.baseUrl}` + '/dmsDocuments/' + docId + "/versionCall");
  }

  getDocumentByDocIdFirstTime(docId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      docId + '/firstCall',
    );
  }

  createBulkDmsDocument(data: any) {
    return this.http.post(`${this.baseUrl}` + '/dmsDocuments/bulkUpload', data);
  }

  createDmsDocument(data: any) {
    return this.http.post(`${this.baseUrl}` + '/dmsDocuments', data);
  }
  getDocumentType(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/getdcumntType',
      data,
    );
  }

  getDocumentWatermark(data: any, loaderSkip: boolean = false) {
    // const token = 'my JWT';
    // let headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    let headers = new HttpHeaders();
    if (loaderSkip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }

    return this.http.post(
      `${this.baseUrl}/dmsDocuments/getdcumntWatermark`,
      data,
      { headers },
    );
  }

  updateDmsDocument(data: any) {
    return this.http.put(`${this.baseUrl}` + '/dmsDocuments', data);
  }

  deleteDmsDocuments(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/dmsDocuments', httpOptions1);
  }

  getFolderActionLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + '/dmsFolders/getActions', data);
  }

  getDocumentActionLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + '/dmsDocuments/getActions', data);
  }

  getSubFolderPrivUser(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsFolders/' + folderId + '/getFolderPrivUser',
    );
  }

  getPrivForHomePage() {
    return this.http.get(`${this.baseUrl}` + '/dmsFolders/getPrivForHomePage');
  }

  getDownloadPrivForFolder(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsFolders/' +
      folderId +
      '/getDownloadPrivForFolder',
    );
  }

  getDownloadPrivForHomePage() {
    return this.http.get(
      `${this.baseUrl}` + '/dmsFolders/getDownloadPrivForHomePage',
    );
  }

  getDocumentPrivUser(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      folderId + '/getDocumentPrivUser',
    );
  }

  getDmsFolderDataById(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsFolders/' + folderId + '/byfolderId',
    );
  }

  searchDocuments(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/searchDocuments',
      data,
    );
  }

  setDocumentBreadcrumbList(data: any) {
    this.documentsBreadcrumbList = data;
  }

  getDocumentBreadcrumbList() {
    return this.documentsBreadcrumbList;
  }

  // DMS Folders
  getDmsFoldersVwDetails() {
    return this.http.get(`${this.baseUrl}` + '/dmsFoldersVw/All');
  }

  // Qms Task Extensions
  getQmsTaskExtensionsVwDetailByExtensionId(extensionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskExtensionsVw/' +
      extensionId +
      '/byExtensionId',
    );
  }

  // Qms Task Extensions
  getAllExtensionsByRefNo(refNo: number) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskExtensionsVw/' +
      refNo +
      '/getAllExtensionsByRefNo',
    );
  }

  getTaskExtensionButtons(request: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskExtensionsVw/callGetTaskExtensionButtonsPro',
      request,
    );
  }
  submitActivityExtensions(request: any) {
    return this.http.post(
      `${this.baseUrl}` +
      '/qmsTaskExtensionsVw/callSubmitActivityExtensionsPro',
      request,
    );
  }
  reviewActivityExtensions(request: any) {
    return this.http.post(
      `${this.baseUrl}` +
      '/qmsTaskExtensionsVw/callReviewActivityExtensionsPro',
      request,
    );
  }
  approveActivityExtensions(request: any) {
    return this.http.post(
      `${this.baseUrl}` +
      '/qmsTaskExtensionsVw/callApproveActivityExtensionsPro',
      request,
    );
  }
  createQmsTaskExtensions(request: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsTaskExtensionsVw', request);
  }

  updateQmsTaskExtensions(request: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsTaskExtensionsVw', request);
  }

  deleteQmsTaskExtensions(taskExtensionsFieldData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(taskExtensionsFieldData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskExtensionsVw',
      httpOptions1,
    );
  }

  getAllQmsBusinessAreas() {
    return this.http.get(`${this.baseUrl}` + '/qmsBusinessArea/getAllBusinessArea');
  }

  getQmsBusinessAreaByBusinessAreaId(businessAreaId: any,) {
    return this.http.get(`${this.baseUrl}` + '/qmsBusinessArea/' + businessAreaId + "/byBusinessAreaId");
  }

  getQmsBusinessAreasByModule(module: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsBusinessArea/' + module + "/byModule");
  }

  createQmsBusinessArea(businessArea: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsBusinessArea', businessArea);
  }

  updateQmsBusinessArea(businessArea: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsBusinessArea', businessArea,);
  }

  deleteQmsBusinessArea(businessArea: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(businessArea),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsBusinessArea',
      httpOptions1,
    );
  }

  getDocumentsToViewForDms(
    trainingId: any,
    version: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      trainingId +
      '/' +
      version +
      '/document',
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  savePublishedDocWithCoverPage(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/savePublishedDoc',
      data,
    );
  }

  getDocumentDetailsFromTable(
    trainingId: any,
    version: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      trainingId +
      '/' +
      version +
      '/getDOcumentDetails',
    );
  }

  getDocumentsToViewWithCoverPageForDms(
    trainingId: any,
    version: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      trainingId +
      '/' +
      version +
      '/documentWithCoverPage',
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }
  downloadIssuanceFile(

    issuanceId: any,
    filename: any,
  ) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .get(
        `${this.baseUrl}` +
        '/dmsDocuments/' +
        issuanceId +
        '/ByIssuanceId',
        {
          // headers,
          responseType: 'blob' as 'json'
        },
      )
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  getDocumentsToViewForDmsOnlyByNo(documentId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      documentId +
      '/documentByNo',
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  downloadDocuments(docId: any, version: any, filename: any,) {
    this.http.get(`${this.baseUrl}` + '/dmsDocuments/' + docId + '/' + version + '/document',
      { responseType: 'blob' as 'json' },
    )
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  eviDocuments(evidenceDocId: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .get(
        `${this.baseUrl}` +
        '/tmsUserTrainingCompletionEvidencesController/document/' +
        evidenceDocId +
        '/byEvidenceId',
        {
          //  headers,
          responseType: 'blob' as 'json'
        },
      )
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );

        downloadLink.setAttribute('download', 'Training_Evidence');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }
  downloadDocumentsDmsrevision(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/getdcumntdownloadforrevision',
      data,
      {
        // headers,
        responseType: 'blob' as 'json'
      },
    );
  }

  downloadDocumentsDms(data: any, filename: any, loaderSkip: boolean = false) {
    // const token = 'my JWT';
    // let headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    let headers = new HttpHeaders();
    if (loaderSkip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/getdcumntdownload',
      data,
      { headers, responseType: 'blob' as 'json' },
    );
  }

  // downloadDocumentsDmsForPrinter(data: any, filename: string) {
  //   return this.http.post(`${this.baseUrl}/dmsDocuments/getdcumntPrint`, data, {
  //     params: {
  //       fileName: filename,
  //     },
  //     responseType: 'arraybuffer',
  //     observe: 'response',
  //   });
  // }

  downloadDocumentsDmsForPrinterPreview(data: any, filename: string) {
    return this.http.post(
      `${this.baseUrl}/dmsDocuments/getdcumntPrintPreview`,
      data,
      {
        params: {
          fileName: filename,
        },
        responseType: 'arraybuffer',
        observe: 'response',
      },
    );
  }

  downloadReadcatedDocument(data: any, loaderSkip: boolean = false) {
    // const token = 'my JWT';
    // let headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    let headers = new HttpHeaders();
    if (loaderSkip) headers = headers.set('X-Skip-Loader', 'true');
    return this.http.put(
      `${this.baseUrl}/dmsDocuments/getRedactDocDownload`,
      data,
      {
        headers,
        responseType: 'blob' as 'json',
      },
    );
  }

  saveRedactedDocument(formData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocuments/getRedactDocSave',
      formData,
    );
  }

  bulkSaveDocumentsDms(data: any, loaderSkip: boolean = false) {
    let headers = new HttpHeaders();
    if (loaderSkip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }

    return this.http.put(
      `${this.baseUrl}/dmsDocuments/bulkDodumentSave`,
      data,
      { headers },
    );
  }

  bulkDownloadDocumentsDms(data: any, loaderSkip: boolean = false) {
    // const token = 'my JWT';
    // let headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    let headers = new HttpHeaders();
    if (loaderSkip) headers = headers.set('X-Skip-Loader', 'true');

    return this.http.post(
      `${this.baseUrl}/dmsDocuments/bulkDodumentDownload`,
      data,
      {
        headers,
        responseType: 'blob' as 'json',
      },
    );
  }
  // bulkDownloadDocumentsRevision(data: any) {
  //   const token = 'my JWT';
  //   const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
  //   return this.http.post(
  //     `${this.baseUrl}` + '/dmsDocuments/bulkdownloadforrevision',
  //     data,
  //     { headers, responseType: 'blob' as 'json' },
  //   );
  // }

  downloadPdf(data: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    return this.http.post(`${this.baseUrl}` + '/pdf/pdf2', data, {
      // headers,
      responseType: 'blob' as 'json',
    });
  }

  downloadexcel(data: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    return this.http.post(`${this.baseUrl}` + '/excel', data, {
      // headers,
      responseType: 'blob' as 'json',
    });
  }
  downloadexceWithColumnchooser(data: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    return this.http.post(
      `${this.baseUrl}` + '/excel/excelWithColumnChooser',
      data,
      {
        // headers,
        responseType: 'blob' as 'json'
      },
    );
  }
  downloadexcelForChart(data: any, filename: any) {
    return this.http.post(
      `${this.baseUrl}` + '/excel/chartReport',
      data, {
      responseType: 'blob' as 'json',
    }
    ).subscribe((response: any) => {
      let dataType = response.type;
      let binaryData = [];
      binaryData.push(response);
      let downloadLink = document.createElement('a');
      downloadLink.href = globalThis.URL.createObjectURL(
        new Blob(binaryData, { type: dataType }),
      );
      if (filename) downloadLink.setAttribute('download', filename);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      this.isProcessingRep = false;
    });
    // this.http
    //   .post(`${this.baseUrl}` + '/excel/chartReport', data, {
    //     headers,
    //     responseType: 'blob' as 'json',
    //   })

  }

  downloadexcelForChartWithColumns(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/excel/chartReportWithColumns', data, {
        //  headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }
  downloadexcelFoTrainingVsGroup(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/excel/TrainingVsGroup', data, {
        //headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }

  downloadexcelForMainGrid(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/excel/mainGridReport', data, {
        // headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }

  downloadexcelForMainGridTMSOrg(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/excel/mainGridReportTMSOrg', data, {
        //  headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }

  downloadExcel(data: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    return this.http.post(`${this.baseUrl}` + '/excel/chartReport', data, {
      // headers,
      responseType: 'blob' as 'json',
    });
  }

  downloadexcelForPeridicReview(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/excel/peridicReviewReport', data, {
        //  headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }

  downloadPdfFile(data: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    return this.http.post(`${this.baseUrl}` + '/pdf/chartReport', data, {
      //   headers,
      responseType: 'blob' as 'json',
    });
  }

  downloadPdfForChart(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/pdf/chartReport', data, {
        //headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }

  downloadPdfForPeridicReview(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/pdf/peridicReviewReport', data, {
        //headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }
  getQmsTaskEcVwDetailsByOrgIdAndRefNoAndECId(refNo: any, ecId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsTaskEcVw/' + refNo + '/' + ecId + '/byRefNoEcId',
    );
  }

  getTaskEcButtons(qmsTasksECData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskEcVw/getTaskEcButtons',
      qmsTasksECData,
    );
  }
  setTaskEcForApproval(qmsTasksECData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskEcVw/setTaskEcForApproval',
      qmsTasksECData,
    );
  }
  setTaskEcForQaApproval(qmsTasksECData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskEcVw/setTaskEcForQaApproval',
      qmsTasksECData,
    );
  }
  approveTaskEc(qmsTasksECData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskEcVw/approveTaskEc',
      qmsTasksECData,
    );
  }
  qaApproveTaskEc(qmsTasksECData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskEcVw/qaApproveTaskEc',
      qmsTasksECData,
    );
  }

  getQmsTasksEC(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsTaskEcVw/' + refNo + '/byRefNo',
    );
  }

  createQmsTasksEC(qmsTasksECData: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsTaskEcVw', qmsTasksECData);
  }

  updateQmsTasksEC(qmsTasksECData: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsTaskEcVw', qmsTasksECData);
  }

  deleteQmsTasksEC(qmsTasksECData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsTasksECData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskEcVw',
      httpOptions1,
    );
  }

  /* Multi Organization */
  getOneQmsOrganizationPrivileges(orgId?: any) {
    let params = new HttpParams();
    if (orgId) {
      params = params.set('orgId', orgId);
    }
    return this.http.get(`${this.baseUrl}/organizationPrivileges`, { params });
  }

  getDocumentListForTraining(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      parentFolderId + '/forTraining',
    );
  }

  uploadSingleFileToOneQmsServer(formData: any, loaderskip?: boolean) {
    let headers = new HttpHeaders();
    if (loaderskip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }
    return this.http.post(`${this.baseUrl}/fileUploader/singleFile`, formData, {
      reportProgress: true,
      observe: 'events',
      headers,
    });
  }

  fileUploadToServer(formData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/fileUploader/singleFile',
      formData,
    );
  }

  fileUploadToServerCertificate(formData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/fileUploader/uploadCertificate',
      formData,
    );
  }

  multiFileUploadToServer(formData: any): Observable<HttpEvent<any>> {
    const req = new HttpRequest(
      'POST',
      `${this.baseUrl}/fileUploader/uploadMultipleFile`,
      formData,
      {
        reportProgress: true,
      },
    );

    return this.http.request(req);
  }

  getQmsTaskEcActionVwDetails(refNo: any, ecId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskActionEcVw/' +
      refNo +
      '/' +
      ecId +
      '/byRefNoEcId',
    );
  }

  getQmsTaskEcActionVwDetailsByOrgIdAndRefNoAnEcIdActionEcId(
    refNo: any,
    ecId: any,
    actionEcId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskActionEcVw/' +
      refNo +
      '/' +
      ecId +
      '/' +
      actionEcId +
      '/byRefNoEcIdActionEcId',
    );
  }

  createQmsTasksECAction(ecActionsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskActionEcVw',
      ecActionsData,
    );
  }

  updateQmsTasksECAction(ecActionsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsTaskActionEcVw',
      ecActionsData,
    );
  }

  deleteQmsTasksECAction(ecActionsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(ecActionsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskActionEcVw',
      httpOptions1,
    );
  }

  getQmsTaskEcParticipantsVwDetailsByOrgIdAndRefNoAndEcId(
    refNo: any,
    ecId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskECParticipantsVw/' +
      refNo +
      '/' +
      ecId +
      '/byRefNoEcId',
    );
  }

  getQmsTaskEcParticipantsVwDetailsByOrgIdAndRefNoAndEcIdAndParticipantId(
    refNo: any,
    ecId: any,
    participantId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskECParticipantsVw/' +
      refNo +
      '/' +
      ecId +
      '/' +
      participantId +
      '/byRefNoEcIdPartcId',
    );
  }

  createQmsTasksECParticipants(ecParticipantsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskECParticipantsVw',
      ecParticipantsData,
    );
  }

  updateQmsTasksECParticipants(ecParticipantsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsTaskECParticipantsVw',
      ecParticipantsData,
    );
  }

  deleteQmsTasksECParticipants(ecParticipantsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(ecParticipantsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskECParticipantsVw',
      httpOptions1,
    );
  }

  getQmsTaskEcDocumentsVwDetailsByOrgIdAndRefNoAndEcIdAndDocumentId(
    refNo: any,
    ecId: any,
    documentId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskEcDocumentsVw/' +
      refNo +
      '/' +
      ecId +
      '/' +
      documentId +
      '/byRefNoEcIdDocId',
    );
  }

  createQmsTasksECDocuments(addEcDocumentsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsTaskEcDocumentsVw',
      addEcDocumentsData,
    );
  }

  updateQmsTasksECDocuments(ecParticipantsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsTaskEcDocumentsVw',
      ecParticipantsData,
    );
  }

  deleteQmsTasksECDocuments(ecParticipantsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(ecParticipantsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsTaskEcDocumentsVw',
      httpOptions1,
    );
  }

  searchUsersForDmsDocuments(
    searchOneQmsUserVwDetails: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/usersVw/searchUserForDocuments',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  tmsGroupUserActiveInactive(tmsGroupUserActiveInactiveData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/tmsGroupUsers/activateInactivateProcedure',
      tmsGroupUserActiveInactiveData,
    );
  }

  tmsGroupActiveInactive(tmsGroupActiveInactiveData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/tmsGroupTrainings/activateInactivateProcedure',
      tmsGroupActiveInactiveData,
    );
  }

  dmsGroupActiveInactive(dmsGroupUserActiveInactiveData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsGroupUsers/activateInactivateProcedure',
      dmsGroupUserActiveInactiveData,
    );
  }

  dmsGroupFolderActiveInactive(dmsGroupFoldersFieldData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsGroupFolders/activateInactivateProcedure',
      dmsGroupFoldersFieldData,
    );
  }

  //typeSettings
  getTypeSettingsByGrpIdGrpDetailId(groupId: any, groupDetailId: any,) {
    return this.http.get(`${this.baseUrl}` + '/typeSettings/' + groupId + '/' + groupDetailId + '/byGrpIdGrpDetailId');
  }

  getTypeSettingsByType(groupId: any, groupdetilId: any, type: any) {
    const obj = { groupId: '' + groupId, groupdetilId: '' + groupdetilId, type: type, };
    return this.http.post(`${this.baseUrl}` + '/typeSettings/byType', obj);
  }

  getQmsGroupDetailTypeSettingsVwDetailsBySettingsId(groupId: any, groupDetailId: any, settingsId: any,) {
    return this.http.get(`${this.baseUrl}` + '/typeSettings/' + groupId + '/' + groupDetailId + '/' + settingsId + '/bySettingsId');
  }

  createQmsGroupDetailTypeSettings(qmsGroupDetailTypeSettingsdData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/typeSettings',
      qmsGroupDetailTypeSettingsdData,
    );
  }

  updateQmsGroupDetailTypeSettings(qmsGroupDetailTypeSettingsdData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/typeSettings',
      qmsGroupDetailTypeSettingsdData,
    );
  }

  deleteQmsGroupDetailTypeSettings(qmsGroupDetailTypeSettingsdData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(qmsGroupDetailTypeSettingsdData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/typeSettings',
      httpOptions1,
    );
  }

  getRootNodes(isFrom: any) {
    return this.http.get(`${this.baseUrl}` + "/pendingTasksCntVw/" + isFrom + "/byisFrom");
  }


  getSubNodesForMyTask(moduleName: any, isFrom: any) {
    return this.http.get(`${this.baseUrl}` + "/pendingTasksCntVw/" + moduleName + "/" + isFrom + "/getSubNode");
  }

  getSubNodesForSubModule(moduleName: any, subModuleName: any, isFrom: any) {
    return this.http.get(`${this.baseUrl}` + "/pendingTasksCntVw/" + moduleName + "/" + subModuleName + "/" + isFrom + "/bymoduleNameAndsubModuleNameAndisFrom");
  }

  getTaskDetail(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/myPendingTasksVw/taskList',
      data,
    );
  }

  getTrainingTaskDetails() {
    return this.http.get(`${this.baseUrl}` + "/pendingTasksCntVw/trainingTasks");
  }

  getSubTaskDetail(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/myPendingTasksVw/subtaskList',
      data,
    );
  }
  callSetDefaultGrouop(request: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsUserDefaultGroup/callSetDefaultGrouop',
      request,
    );
  }

  getFlexifieldsListForDocument(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/flexifieldsSetup/forDocuments',
      data,
    );
  }

  getQualityFlexibleFieldsList(data: any) {
    return this.http.put(`${this.baseUrl}` + '/flexifieldsSetup/getQmsFlexibleFields', data);
  }

  getQualityFlexibleFieldsValue(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/flexifieldData/' +
      refNo +
      '/' +
      0 +
      '/byrefNoAndVersion',
    );
  }

  getFlexifieldDataWithDocIdAndVersion(docId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/flexifieldData/' +
      docId +
      '/' +
      version +
      '/byrefNoAndVersion',
    );
  }

  addFlexifieldData(data: any) {
    return this.http.post(`${this.baseUrl}` + '/flexifieldData', data);
  }

  updateFlexifieldData(data: any) {
    return this.http.put(`${this.baseUrl}` + '/flexifieldData', data);
  }
  getqmsUserDefaultGroup(moduleName: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsUserDefaultGroup/' + moduleName + '/byModule',
    );
  }

  getDocumentButtonLabels(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocuments/getButtonLabels',
      data,
    );
  }

  getUserListOfDocForStageUser(
    stageName: any,
    folderId: any,
    isBlinded: any
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      stageName +
      '/' +
      folderId +
      '/' +
      isBlinded + '/forStageUsers',
    );
  }

  performButtonOperationForDocument(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/performOperation',
      multipartData,
    );
  }

  getOneQmsTaskActionsHistoryVwDetails(taskNo: any) {
    return this.http.get(`${this.baseUrl}/oneQmsTaskActionsHistoryVw/${taskNo}/history`);
  }

  getOneQmsSentTopics() {
    return this.http.get(`${this.baseUrl}` + '/oneQmsSentTopics');
  }

  getOneQmsSentTopicsForActivity(taskNo: any) {
    return this.http.get(`${this.baseUrl}` + "/oneQmsSentTopics/" + taskNo + "/topicsByTaskNo");
  }

  getOneQmsReceivedTopics() {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsReceivedTopics'
    );
  }

  getOneQmsReceivedTopicsForActivity(taskNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsReceivedTopics/' + taskNo + '/byTaskNo'
    );
  }

  getQmsTopicDetailsByTopicId(topicId: any,) {
    return this.http.get(`${this.baseUrl}` + '/oneQmsTopicDetailsVw/' + topicId + "/byTopicId");
  }

  createTopic(topicData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsTopics/createTopics',
      topicData,
    );
  }

  markTopicAsReadUnread(topicData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsTopics/readUnread',
      topicData,
    );
  }

  markTopicAsClosed(topicData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsTopics/closeTopic',
      topicData,
    );
  }

  markTopicAsActive(topicData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsTopics/reactivateTopic',
      topicData,
    );
  }

  storeTopicAttachment(formData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsTopics/topicAttachment',
      formData,
    );
  }

  getTopicAttachment(topicId: any, topicDetailId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsTopicAttachments/' +
      topicId +
      '/' +
      topicDetailId +
      '/byTopicDeatails',
    );
  }

  downloadAttachment(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsTopicAttachments/downloadAttachments',
      data,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  getModuleBasedPrivilegedUsersList(module: any) {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserPrivsVw/getUserPrivilieageFor/${module}`,
    );
  }

  getModuleBasedPrivilegedUsersListForTopics(module: any, userName: any) {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserPrivsVw/${module}/${userName}/topicUsersSearch`,
    );
  }

  getCapaVwDetailsByCapaNo(capaNo: any) {
    return this.http.get(`${this.baseUrl}` + '/capa/' + capaNo + '/byCapaNo');
  }

  searchCapa(obj: any,): Observable<oneQmsUsersInterface> {
    return this.http.post<oneQmsUsersInterface>
      (this.baseUrl + '/capa/searchCapa', JSON.stringify(obj), this.httpOptions,)
      .pipe(catchError((error) => throwError(() => new Error(`${error.status} - ${error.error?.message}`),),),);
  }

  createCapa(data: any) {
    return this.http.post(`${this.baseUrl}` + '/capa', data);
  }

  updateCapa(data: any) {
    return this.http.put(`${this.baseUrl}` + '/capa', data);
  }

  getDvByDvNo(dvNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/qmsDv/' + dvNo + '/byDvNo');
  }

  createDv(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsDv', data);
  }

  updateDv(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsDv', data);
  }

  performOperationForFolder(multipartData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsFolders/performActions',
      multipartData,
    );
  }

  getGroupUserPrivForFolders(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsFolders/' +
      folderId +
      '/getGroupUserPrivsOfFolder',
    );
  }

  getGroupPrivForFolders(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/dmsFolders/' + folderId + '/getGroupPrivsOfFolder',
    );
  }

  getDocumentExtensions(documentId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentExtensions/' +
      documentId +
      '/' +
      version +
      '/bydocumentIdandversion',
    );
  }

  getDocumentExtensionById(documentId: any, version: any, extensionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentExtensions/' +
      documentId +
      '/' +
      version +
      '/' +
      extensionId +
      '/bydocumentIdandversionandextensionId',
    );
  }

  addDocumentExtension(data: any) {
    return this.http.post(`${this.baseUrl}` + '/documentExtensions', data);
  }

  updateDocumentExtension(data: any) {
    return this.http.put(`${this.baseUrl}` + '/documentExtensions', data);
  }

  deleteDocumentExtension(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/documentExtensions',
      httpOptions1,
    );
  }

  getDocumentWithdrawal(documentId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentWithdrawals/' +
      documentId +
      '/' +
      version +
      '/bydocumentIdandversion',
    );
  }

  getDocumentWithdrawalById(documentId: any, version: any, withdrawalId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentWithdrawals/' +
      documentId +
      '/' +
      version +
      '/' +
      withdrawalId +
      '/bydocumentIdandversionandwithdrawalId',
    );
  }
  getDocumentDestructionById(documentId: any, version: any, destructId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentDestruction/' +
      documentId +
      '/' +
      version +
      '/' +
      destructId +
      '/bydocumentIdAndversionAnddestructId',
    );
  }
  addDocumentWithdrawal(data: any) {
    return this.http.post(`${this.baseUrl}` + '/documentWithdrawals', data);
  }

  addDocumentDestruction(data: any) {
    return this.http.post(`${this.baseUrl}` + '/documentDestruction', data);
  }
  getDocumentDestruction(documentId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentDestruction/' +
      documentId +
      '/' +
      version +
      '/bydocumentIdandversion',
    );
  }

  updateDocumentDestruction(data: any) {
    return this.http.put(`${this.baseUrl}` + '/documentDestruction', data);
  }
  deleteDocumentDestruction(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/documentDestruction',
      httpOptions1,
    );
  }

  updateDocumentWithdrawal(data: any) {
    return this.http.put(`${this.baseUrl}` + '/documentWithdrawals', data);
  }

  deleteDocumentWithdrawal(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/documentWithdrawals',
      httpOptions1,
    );
  }

  getCrForDocuments(groupId: any) {
    return this.http.get(`${this.baseUrl}` + '/cr/' + groupId + "/forDmsByGrpId");
  }

  getAssociatedDocumentsDetail(
    docId: any,
    version: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      docId +
      '/' +
      version +
      '/associatedDocuments',
    );
  }

  switchOperationIncident(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsIn/switchOperation', data);
  }

  raiseIncident(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsIn', data);
  }

  updateIncident(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsIn', data);
  }

  getIncidentDetailsByInNo(inNo: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsIn/' + inNo + '/byInNo');
  }

  unlockTraining(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainings/unlockTrainings',
      data,
    );
  }

  getGroupTrainingDetailsById(groupId: any, trainingId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsGroupTrainings/' +
      groupId +
      '/' +
      trainingId +
      '/' +
      version +
      '/byGrTrIdVr',
    );
  }

  //QmsQiVw
  getQiVwDetailsByQiNo(qiNo: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsQiVw/' + qiNo + '/byQiNo');
  }

  createQmsQi(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsQiVw', data);
  }

  updateQmsQi(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsQiVw', data);
  }
  getDocumentsForAssociatedDoc(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      parentFolderId + '/forAssociatedDocs',
    );
  }

  getDocumentsForDownloadDoc(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      parentFolderId + '/forDownloadDocs',
    );
  }

  getDocumentsForFormsAndLogs(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      parentFolderId + '/forFormsAndLogs',
    );
  }

  getCcDetailsByCcNo(ccNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/cc/' + ccNo + "/byCcNo",
    );
  }

  raiseComplaint(data: any) {
    return this.http.post(`${this.baseUrl}` + '/cc', data);
  }

  updateComplaint(data: any) {
    return this.http.put(`${this.baseUrl}` + '/cc', data);
  }

  switchComplaintGroup(data: any) {
    return this.http.post(`${this.baseUrl}` + '/cc/switchOperation', data);
  }

  getCcDetailsByCcpId(ccpId: any) {
    return this.http.get(`${this.baseUrl}` + '/ccp/' + ccpId + "/byCcpId");
  }

  getAllProductsByCcNo(ccNo: any) {
    return this.http.get(`${this.baseUrl}` + '/ccp/' + ccNo + "/byCcNo");
  }

  createCcProduct(data: any) {
    return this.http.post(`${this.baseUrl}` + '/ccp', data);
  }

  updateCcProduct(data: any) {
    return this.http.put(`${this.baseUrl}` + '/ccp', data);
  }

  deleteCcProduct(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/ccp', httpOptions1);
  }

  getAuMasterByGroupId(groupId: any) {
    return this.http.get(`${this.baseUrl}` + '/auMaster/' + groupId + "/byGroupId");
  }

  getAuMasterByAuMasterId(auditMasterId: any) {
    return this.http.get(`${this.baseUrl}` + '/auMaster/' + auditMasterId + "/byAuditMasterId");
  }

  createAuMaster(data: any) {
    return this.http.post(`${this.baseUrl}` + '/auMaster', data);
  }

  updateAuMaster(data: any) {
    return this.http.put(`${this.baseUrl}` + '/auMaster', data);
  }

  deleteAuMaster(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/auMaster', httpOptions1);
  }

  getAuByAuNo(auNo: any) {
    return this.http.get(`${this.baseUrl}` + '/au/' + auNo + "/byAuNo");
  }

  createAu(data: any) {
    return this.http.post(`${this.baseUrl}` + '/au', data);
  }

  updateAu(data: any) {
    return this.http.put(`${this.baseUrl}` + '/au', data);
  }

  deleteAu(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/au', httpOptions1);
  }

  searchInstructorTrainingsByCondition(searchData: any): Observable<any> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/ScheduledTrainings/searchTrainings',
        JSON.stringify(searchData),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  //tms reports
  getOneQmsUserTrainingsRepVwMain(
    type: any,
    val: any,
    attaptedVal: any,
  ) {
    const data = {
      val: val,
      type: type,
      attaptedVal: attaptedVal,
    };
    return this.http.put(`${this.baseUrl}` + '/tmsUserTrainingsRepCntVw', data);
  }

  /* Multi Organization */
  getOneQmsUserTrainingsRepVwMainOrg(
    orgId: any,
    userId: any,
    type: any,
    val: any,
    attaptedVal: any,
  ) {
    const data = {
      orgId: orgId,
      userId: userId,
      val: val,
      type: type,
      attaptedVal: attaptedVal,
    };
    return this.http.put(
      `${this.baseUrl}` + '/tmsUserTrainingsRepCntVw/org',
      data,
    );
  }
  getOneQmsOrgMain(
    type: any,
    val: any,
    attaptedVal: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsUserTrainingsRepCntVw/' +
      val +
      '/' +
      type +
      '/' +
      attaptedVal + "/orglevel",
    );
  }

  /* Multi Organization */
  getOneQmsUserTrainingsRepVwMainForGroup(
    orgId: any,
    type: any,
    val: any,
    attaptedVal: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsUserTrainingsRepCntVw/' +
      orgId +
      '/' +
      val +
      '/' +
      type +
      '/' +
      attaptedVal + '/forGroup',
    );
  }

  /* Multi Organization */
  getOneQmsUserTrainingsRepVwDetails(
    orgId: any,
    type: any,
    val: any,
    selectedVal: any,
    withContent: any,
  ) {
    const data = {
      orgId: orgId,
      val: val,
      type: type,
      selectedVal: selectedVal,
      withContent: withContent,
    };
    return this.http.put(
      `${this.baseUrl}` + '/tmsUserTrainingsRepCntVw/details',
      data,
    );
  }

  /* Multi Organization */
  getOneQmsUserTrainingsRepVwDetailsForOrg(
    orgId: any,
    type: any,
    val: any,
    selectedVal: any,
    withContent: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsUserTrainingsRepCntVw/' +
      orgId +
      '/' +
      val +
      '/' +
      type +
      '/' +
      selectedVal +
      '/' +
      withContent + '/detailsOrgLevel',
    );
  }
  getOneQmsUserTrainingsRepVwTrainingCountByOrg(
    type: any,
    val: any,
    selectedVal: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsUserTrainingsRepCntVw/' +
      val +
      '/' +
      type +
      '/' +
      selectedVal + '/orgTrainingCouts',
    );
  }
  getOneQmsUserTrainingsRepVwUsersCountByOrg(

    type: any,
    val: any,
    selectedVal: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsUserTrainingsRepCntVw/' +
      val +
      '/' +
      type +
      '/' +
      selectedVal + '/orgUsersCouts',
    );
  }
  getOneQmsUserTrainingsRepVw(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/userTrainingsRepVw/status',
      data,
    );
  }
  getOneQmsUserTrainingsRepVwUserLevel(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/userTrainingsRepVw/statusUserLevel',
      data,
    );
  }
  getOneQmsUserTrainingsRepVwGroupLevel(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/userTrainingsRepVw/statusTrainingLevel',
      data,
    );
  }
  getOneQmsUserTrainingsRepVwDepartmentLevel(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/userTrainingsRepVw/statusDepartmentUserLevel',
      data,
    );
  }

  /* Multi Organization */
  getInstructorTrainer(orgId?: any) {
    return this.http.get(`${this.baseUrl}/ScheduledTrainings/getTrainers`, {
      params: { ...(orgId != null && { orgId: orgId }) },
    });
  }

  getOneQmsUserInstructorTrainingsVw(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/userTrainingsRepVw/statusInstructorTrainingLevel',
      data,
    );
  }
  retakeTraining(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingsRepVw/retake',
      data,
    );
  }
  markAsCompletedTrainings(formData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingsRepVw/markAsCompleted',
      formData,
    );
  }

  removeTrainings(formData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingsRepVw/remove',
      formData,
    );
  }
  getScheduledTrainingById(scheduledTrainingId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/scheduledTrainings/' +
      scheduledTrainingId +
      '/byScheduledTrainingId',
    );
  }
  //Review Period Add User
  addUserForReview(reviewPeriodData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/userTrainingReviewPeriod',
      reviewPeriodData,
    );
  }
  //Review Period Add User
  updateUserForReview(reviewPeriodData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingReviewPeriod',
      reviewPeriodData,
    );
  }

  updateUserTrainingReviewStatus(reviewPeriodData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/userTrainingRecordReview',
      reviewPeriodData,
    );
  }
  //Review Period Delete User
  deleteUserPriod(reviewPeriodData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(reviewPeriodData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/userTrainingReviewPeriod',
      httpOptions1,
    );
  }

  getUserPriodList(reviewPeriodId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/userTrainingReviewPeriod/' +
      reviewPeriodId +
      '/byReviewPeriodId',
    );
  }
  getUserEditPriodList(reviewPeriodId: any, selectedUserId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/userTrainingReviewPeriod/' +
      reviewPeriodId +
      '/' +
      selectedUserId +
      '/byUserId',
    );
  }
  addScheduledTraining(data: any) {
    return this.http.post(`${this.baseUrl}` + '/scheduledTrainings', data);
  }
  updateScheduledTraining(data: any) {
    return this.http.put(`${this.baseUrl}` + '/scheduledTrainings', data);
  }

  deleteScheduledTraining(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/scheduledTrainings',
      httpOptions1,
    );
  }

  getButtonLabelsForScheduleTraining(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/scheduledTrainings/buttonLabels',
      data,
    );
  }

  getTrainingScheduleUsers(scheduledTrainingId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/scheduledTrainings/' +
      scheduledTrainingId +
      '/getUsers',
    );
  }

  handledScheduleUsers(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/scheduledTrainings/addusers',
      data,
    );
  }

  performOperationsForTrainingSchedule(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/scheduledTrainings/performOperation',
      data,
    );
  }

  getInstructorApprovers() {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserPrivsVw/instructorTrainingApprovers`,
    );
  }

  searchUsersForInstructorTraining(
    searchOneQmsUserVwDetails: any,
  ): Observable<any> {
    return this.http
      .post<any>(
        this.baseUrl + '/oneQmsUserPrivsVw/searchInstructorUsers',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  getAllAuFindingsByAuNo(auNo: any) {
    return this.http.get(`${this.baseUrl}` + '/auFindings/' + auNo + "/getFindingsByAuNo");
  }

  getAuFindingByFindingId(findingId: any) {
    return this.http.get(`${this.baseUrl}` + '/auFindings/' + findingId + "/byFindingId");
  }

  createAuFinding(data: any) {
    return this.http.post(`${this.baseUrl}` + '/auFindings', data);
  }

  updateAuFinding(data: any) {
    return this.http.put(`${this.baseUrl}` + '/auFindings', data);
  }

  deleteAuFinding(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/auFindings',
      httpOptions1,
    );
  }

  getFindingsButtons(finding: any) {
    return this.http.post(`${this.baseUrl}` + '/auFindings/getButtons', finding);
  }

  performFindingsAction(finding: any) {
    return this.http.post(`${this.baseUrl}` + '/auFindings/performAction', finding);
  }

  getAuFollowupByFollowupId(followupId: any,) {
    return this.http.get(`${this.baseUrl}` + '/auFollowups/' + followupId + "/byFollowupId");
  }

  createQmsAuFollowup(followup: any) {
    return this.http.post(`${this.baseUrl}` + '/auFollowups', followup);
  }

  updateQmsAuFollowup(followup: any) {
    return this.http.put(`${this.baseUrl}` + '/auFollowups', followup);
  }

  deleteQmsAuFollowup(followup: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(followup),
    };
    return this.http.delete<any>(
      this.baseUrl + '/auFollowups',
      httpOptions1,
    );
  }

  getAuParticipantsByAuNo(auNo: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsAuParticipants/' + auNo + "/getParticipantsByAuNo");
  }

  getAuParticipantByPartcipantId(participantId: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsAuParticipants/' + participantId + "/getAuParticipantByParticipantId");
  }

  createQmsAuParticipant(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsAuParticipants', data);
  }

  updateQmsAuParticipant(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAuParticipants', data);
  }

  deleteQmsAuParticipant(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/qmsAuParticipants',
      httpOptions1,
    );
  }

  //AU-Recommendations
  getRecommendationByRecommendationId(recommendationId: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsAuRecommendations/' + recommendationId + "/byRecommendationId");
  }

  createQmsAuRecommendation(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsAuRecommendations', data);
  }

  updateQmsAuRecommendation(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAuRecommendations', data);
  }

  deleteQmsAuRecommendation(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/qmsAuRecommendations', httpOptions1);
  }

  getQmsAuQuestionsByAuNO(auNo: any) {
    return this.http.get(`${this.baseUrl}` + '/auQuestions/' + auNo + "/byAuNo");
  }

  getTeamDetailsByStatuswise() {
    return this.http.get(`${this.baseUrl}` + '/userTrainings/managerStatus');
  }

  createQmsAuQuestion(data: any) {
    return this.http.post(`${this.baseUrl}` + '/auQuestions', data);
  }

  updateQmsAuQuestion(data: any) {
    return this.http.put(`${this.baseUrl}` + '/auQuestions', data);
  }

  deleteQmsAuQuestion(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/auQuestions',
      httpOptions1,
    );
  }

  //
  createQmsOosQuestion(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsOosQuestionsVw', data);
  }

  updateQmsOosQuestion(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsOosQuestionsVw', data);
  }

  deleteQmsOosQuestion(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(
      this.baseUrl + '/qmsOosQuestionsVw',
      httpOptions1,
    );
  }

  getBadgeRangeForTmsUser() {
    return this.http.get(`${this.baseUrl}` + '/badgeRanges/getBadgeName');
  }

  getBadgeRangeByBadgeName(badgeName: any) {
    return this.http.get(
      `${this.baseUrl}` + '/badgeRanges/' + badgeName + '/byBadgeName',
    );
  }

  createBadgeRange(data: any) {
    return this.http.post(`${this.baseUrl}` + '/badgeRanges', data);
  }

  updateBadgeRange(data: any) {
    return this.http.put(`${this.baseUrl}` + '/badgeRanges', data);
  }

  deleteBadgeRange(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/badgeRanges', httpOptions1);
  }

  getUserDetailsForTrainingDashboard(userId?: any) {
    return this.http.get(`${this.baseUrl}/usersVw/getUserDetails`, {
      params: { ...(userId != null && { userId: userId }) },
    });
  }

  getCategoriesForTrainingDash() {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserPrivsVw/trainingCategories`,
    );
  }

  getGroupsForTrainingDash() {
    return this.http.get(
      `${this.baseUrl}` + '/tmsGroupTrainings/trainingGroupForDashboard',
    );
  }

  getDocumentsForTrainingDash() {
    return this.http.get(

      `${this.baseUrl}` + '/dmsDocuments/forTrainings');
  }

  generateDynamicGridPdf(data: any) {
    return this.http.post(`${this.baseUrl}` + '/pdf/pdf2', data);
  }

  // Qms Investigation Technique Template
  getAllInvestigationTemplate() {
    return this.http.get(
      `${this.baseUrl}` + '/investigationTechniqueTemplate/getAllTemplate',
    );
  }

  getInvestigationTemplateByTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/investigationTechniqueTemplate/' +
      templateId +
      '/byTemplateId',
    );
  }

  createQmsInvestigationTechniqueTemplate(template: any) {
    return this.http.post(
      `${this.baseUrl}` + '/investigationTechniqueTemplate',
      template,
    );
  }

  updateQmsInvestigationTechniqueTemplate(template: any) {
    return this.http.put(
      `${this.baseUrl}` + '/investigationTechniqueTemplate',
      template,
    );
  }

  deleteQmsInvestigationTechniqueTemplate(template: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(template),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/investigationTechniqueTemplate',
      httpOptions1,
    );
  }

  getQmsDvParticipantsVwDetailsByDvNo(dvNo: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsDvParticipantsVw/' + dvNo + '/getParticipantByDvNo');
  }

  getDvParticipantByParticipantId(dvParticipantId: any) {
    return this.http.get(`${this.baseUrl}` + '/qmsDvParticipants/' + dvParticipantId + '/byParticipantId');
  }

  createQmsDvParticipant(qmsDvParticipant: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsDvParticipants', qmsDvParticipant);
  }

  updateDvParticipant(qmsDvParticipant: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsDvParticipants', qmsDvParticipant);
  }

  deleteQmsDvParticipant(qmsDvParticipant: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', }),
      body: JSON.stringify(qmsDvParticipant),
    };
    return this.http.delete<oneQmsUsersInterface>(this.baseUrl + '/qmsDvParticipants', httpOptions1,);
  }

  getStagesAndStatus(moduleName: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsTaskActionSatgesVw/' + moduleName + '/byModuleName',
    );
  }

  getStageReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/stage',
      data,
    );
  }
  getOOSTypeVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/oosType',
      data,
    );
  }
  getStatusReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/status',
      data,
    );
  }
  getBaReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskBaRepVw/businessArea',
      data,
    );
  }

  getFindingBaReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskBaRepVw/findingBusinessArea',
      data,
    );
  }

  getDepartmentReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/department',
      data,
    );
  }
  getTaskTypeReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/taskType',
      data,
    );
  }
  getActivityReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/activityInterval',
      data,
    );
  }
  getTaskPerformersRepVwReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskPerfomersVw/TaskPerformersArea',
      data,
    );
  }

  getPendingActionRep(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsPendingAction/PendingAction',
      data,
    );
  }
  getPendingTaskForUSer(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/pendingTasksVw/allTasksPending',
      data,
    );
  }
  getPendingActionForUserRep(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsPendingTaskVw/PendingAction',
      data,
    );
  }

  getOverDueRep(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTasksVw/overDueList', data,);
  }

  getDeletedActivityRepList(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTasksVw/deletedList', data,);
  }

  getObsoluteActivityRepList(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTasksVw/obsolutedList', data,);
  }

  searchAllTasksVwDetails(searchData: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsAllTasksVw/searchAllTasksVwDetails', searchData,);
  }

  getExtensionsIntervalRep(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTaskExtensionsIntervalRepVw/ExtensionsIntervalRepArea', data,);
  }

  getEcIntervalRep(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTaskEcIntervalsRepVw/EcIntervalsRepArea', data,);
  }
  getActionIntervalRep(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTaskActionsIntervalRepVw/TaskActionsIntervalRep', data,);
  }

  getinprogressVSTotalReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTasksIntervalsRepVw/activityIntervalWithInProgress',
      data,
    );
  }
  getExtensionReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskExtensionsRepVw/ExtensionsArea',
      data,
    );
  }
  getActionReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskAtionsRepVw/TaskActionsRep',
      data,
    );
  }
  getECReportVal(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsAllTaskEcRepVw/EcArea', data);
  }

  getTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/tableValues',
      data,
    );
  }

  getAUTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/auTableValues',
      data,
    );
  }

  getExtentionTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskExtensionsRepVw/tableValues',
      data,
    );
  }
  getEcTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskEcRepVw/tableValues',
      data,
    );
  }

  getActionTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskAtionsRepVw/tableValues',
      data,
    );
  }

  getCrCountForDoc(crNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      crNo + '/crCount',
    );
  }
  getTaskMilestonesIntervalsRepVw(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/milestonesIntervalsRepVw',
      data,
    );
  }

  // Qms Dv Participants
  getDmsDistributedFolders(folderId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/distributedFolders/' + folderId + '/byfolderId',
    );
  }

  getDmsDistributedFoldersById(folderId: any, distributedFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/distributedFolders/' +
      folderId +
      '/' +
      distributedFolderId +
      '/byfolderIdAnddistributedFolderId',
    );
  }

  createDistributedFolder(data: any) {
    return this.http.post(`${this.baseUrl}` + '/distributedFolders', data);
  }

  updateDistributedFolder(data: any) {
    return this.http.put(`${this.baseUrl}` + '/distributedFolders', data);
  }

  deleteDistributedFolder(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/distributedFolders',
      httpOptions1,
    );
  }

  getFoldersForDistributedFolders(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsFolders/' +
      parentFolderId +
      '/forDistributedFolders',
    );
  }

  getFolderTypeForTree() {
    return this.folderTypeForTree;
  }

  setDocFolderTreeType(data: any) {
    this.folderTypeForTree = data;
  }

  getDocumentTagsList(documentId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentTags/' +
      documentId +
      '/' +
      version +
      '/bydocumentIdAndversion',
    );
  }

  getDocumentTagByTagId(documentId: any, version: any, tagId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentTags/' +
      documentId +
      '/' +
      version +
      '/' +
      tagId +
      '/bydocumentIdAndversionAndtagId',
    );
  }
  getDocumentTagged(taskNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/documentTags/' + taskNo + '/tagged',
    );
  }

  createDocumentTag(data: any) {
    return this.http.post(`${this.baseUrl}` + '/documentTags', data);
  }

  updateDocumentTag(data: any) {
    return this.http.put(`${this.baseUrl}` + '/documentTags', data);
  }

  deleteDocumentTag(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/documentTags',
      httpOptions1,
    );
  }

  getDistinctTags() {
    return this.http.get(`${this.baseUrl}` + '/documentTags/modules');
  }

  searchTasksByTaskId(module: string, taskId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/documentTags/' + module + '/' + taskId + '/search',
    );
  }

  getDocumentTypeOfFolder() {
    return this.documentTypeOfFolder;
  }

  setDocumentTypeOfFolder(data: any) {
    this.documentTypeOfFolder = data;
  }

  getDmsFolderListByDocType(docType: any, parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsFolders/' +
      docType +
      '/' +
      parentFolderId +
      '/forFolderRightClick',
    );
  }

  searchDocumentsBasedOnCondition(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocuments/mainSearchOfDocuments',
      data,
    );
  }

  getDocumentExtensionByOnlyId(extensionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentExtensions/' +
      extensionId +
      '/byextensionId',
    );
  }

  getDocumentWithdrawalByOnlyId(withdrawalId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentWithdrawals/' +
      withdrawalId +
      '/bywithdrawalId',
    );
  }
  getDocumentDestructionByOnlyId(destructId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentDestruction/' +
      destructId +
      '/bydestructId',
    );
  }
  getDmsFoldersVwDetails1(parentFolderId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsFoldersVw/' +
      parentFolderId +
      '/byparentFolderId',
    );
  }

  getSchedulerByName(jobName: any) {
    return this.http.get(`${this.baseUrl}/scheduledJobsVw/${jobName}/job`);
  }

  getSchedulerOptions() {
    return this.http.get(
      `${this.baseUrl}` + '/scheduledJobsVw/schedulerOptions',
    );
  }

  createScheduler(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/scheduledJobsVw/createSchedule',
      data,
    );
  }

  cancelScheduler(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/scheduledJobsVw/cancelSchedule',
      data,
    );
  }

  //admin report

  getUserRepListForStatus() {
    return this.http.get(
      `${this.baseUrl}` + '/usersVw/statusReport/forActiveUsers',
    );
  }
  statusReportForDeactivated() {
    return this.http.get(
      `${this.baseUrl}` + '/usersVw/statusReportForDeactivated',
    );
  }

  getUserRepListForStatusExcluded() {
    return this.http.get(`${this.baseUrl}` + '/usersVw/statusExcludedReport');
  }
  getUserRepListForDepartment() {
    return this.http.get(`${this.baseUrl}` + '/usersVw/dreportListForDept');
  }
  getUserRepListForDesignation() {
    return this.http.get(
      `${this.baseUrl}` + '/usersVw/reportListForDesignations',
    );
  }
  getUserRepListForTimeZone() {
    return this.http.get(`${this.baseUrl}` + '/usersVw/timeZoneForRepUsers');
  }
  getUserLoginInactivityList() {
    return this.http.get(`${this.baseUrl}/oneQmsUserLoginInactivityRepVw/getDataList`);
  }
  getTableAdminReportDataList(data: any) {
    return this.http.put(`${this.baseUrl}` + '/usersVw/getDataList', data);
  }
  getTableAdminReportDataListWithoutConcurrent(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/usersVw/getDataListWithoutConcurent',
      data,
    );
  }
  getTableAdminReportForUserLoginInactivityDataList(data: any) {
    return this.http.put(`${this.baseUrl}/oneQmsUserLoginInactivityRepVw/charData`, data);
  }

  getOneQmsUserLoginFailedAttemptsRepByTimeRange(
    timeRange: any,
    fromDate: any,
    toDate: any,
  ) {
    const data = { timeRange: timeRange, fromDate: fromDate, toDate: toDate };
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsUserLoginFailedAttemptsRepVw/timeRange',
      data,
    );
  }
  getOneQmsUserLoginFailedAttemptsRep(
    searchUserId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsUserLoginFailedAttemptsRepVw/' +
      searchUserId +
      '/withoutRange',
    );
  }
  getLoginsWithoutRange(searchUserId: string) {
    return this.http.get(`${this.baseUrl}/${searchUserId}/withoutRange`);
  }
  getOneQmsUserLoginRepByTimeRange(timeRange: any, fromDate: any, toDate: any) {
    const data = { timeRange: timeRange, fromDate: fromDate, toDate: toDate };
    return this.http.put(
      `${this.baseUrl}/oneQmsUserLoginsRepVw/timeRange`,
      data,
    );
  }
  getOneQmsUserLoginRep(searchUserId: any) {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserLoginsRepVw/${searchUserId}/withoutRange`,
    );
  }
  getOneQmsUserPasswordChangesRep(searchUserId: any) {
    return this.http.get(`${this.baseUrl}/oneQmsUserPasswordChangesRepVw/${searchUserId}/searchingManager`);
  }

  getOneQmsUserActiveUserMappingRep(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/myPendingTasksVw/activityMappingDataList',
      data,
    );
  }
  getOneQmsUserRMUserRep(data: any) {
    return this.http.put(`${this.baseUrl}` + '/usersVw/rmUsersDataList', data);
  }
  //qmsRisksVw
  getRiskByRefNoAndModule(refno: any, module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsRisksVw/' +
      refno +
      '/' +
      module +
      '/byRefNoModule',
    );
  }

  getTaskStage(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksIntervalsRepVw/getTaskStage',
      data,
    );
  }
  createqmsRisksVw(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsRisksVw', data);
  }

  updateqmsRisksVw(data: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsRisksVw', data);
  }

  deleteqmsRisksVw(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<any>(this.baseUrl + '/qmsRisksVw', httpOptions1);
  }

  getCalculateFinalRiskSscoreProcedure(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsRisksVw/getCalculateFinalRiskSscoreProcedure',
      data,
    );
  }

  getUpdateTaskRiskStatusProcedure(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsRisksVw/getUpdateTaskRiskStatusProcedure',
      data,
    );
  }

  getriskSettingsByCategoryAndGroup(
    groupName: any,
    module: any,
    category: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/riskSettings/' +
      groupName +
      '/' +
      module +
      '/' +
      category +
      '/riskByGroupModuleCategory',
    );
  }

  getRiskSettingsFromGroup(groupName: any, module: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/riskSettings/' +
      groupName +
      '/' +
      module +
      '/riskByGroupModule',
    );
  }

  getRiskSettingsByRiskId(riskId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/riskSettings/' + riskId + '/byRiskId',
    );
  }

  createRiskSettings(riskData: any) {
    return this.http.post(`${this.baseUrl}` + '/riskSettings', riskData);
  }

  updateRiskSettings(riskData: any) {
    return this.http.put(`${this.baseUrl}` + '/riskSettings', riskData);
  }

  deleteRiskSettings(riskData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(riskData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/riskSettings',
      httpOptions1,
    );
  }

  getRiskScaleByRiskScaleId(riskScaleId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/riskScale/' + riskScaleId + '/byRiskScaleId',
    );
  }

  createRiskScale(riskData: any) {
    return this.http.post(`${this.baseUrl}` + '/riskScale', riskData);
  }

  updateRiskScale(riskData: any) {
    return this.http.put(`${this.baseUrl}` + '/riskScale', riskData);
  }

  deleteRiskScale(riskScaleData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(riskScaleData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/riskScale',
      httpOptions1,
    );
  }

  performIssuanceHistory(data: any, loaderSkip: boolean = false) {
    let headers = new HttpHeaders();
    if (loaderSkip) headers = headers.set('X-Skip-Loader', 'true');
    return this.http.post(
      `${this.baseUrl}/dmsDocuments/issuanceHistory`,
      data,
      { headers },
    );
  }
  submitJobDmsSingleDocument(data: any, loaderSkip?: boolean) {
    let headers = new HttpHeaders();
    if (loaderSkip) headers = headers.set('X-Skip-Loader', 'true');
    return this.http.post(
      `${this.baseUrl}/dmsDocuments/submitJobOfDocDownload`,
      data,
      { headers },
    );
  }

  getIssuanceHistoryStatusProcedure(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/callIssuanceHistoryStatusProcedure',
      userDetails,
    );
  }

  getAllLocations() {
    return this.http.get(`${this.baseUrl}` + '/locationMaster/getAllLocations');
  }

  getLocationByLocationId(locationId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/locationMaster/' + locationId + '/byLocationId',
    );
  }

  createLocation(locationData: any) {
    return this.http.post(`${this.baseUrl}` + '/locationMaster', locationData);
  }

  updateLocation(locationData: any) {
    return this.http.put(`${this.baseUrl}` + '/locationMaster', locationData);
  }

  deleteLocation(locationData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(locationData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/locationMaster',
      httpOptions1,
    );
  }

  //DMS-NotificationSettings

  getDmsNotificationSettingsVwDetailsByNotificationId(notificationId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsNotificationSettingsVw/' +
      notificationId +
      '/getByNotificationId',
    );
  }

  createDmsNotificationSettings(DmsNotificationSettingsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsNotificationSettingsVw',
      DmsNotificationSettingsData,
    );
  }

  updateDmsNotificationSettings(DmsNotificationSettingsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsNotificationSettingsVw',
      DmsNotificationSettingsData,
    );
  }

  deleteDmsNotificationSettings(DmsNotificationSettingsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(DmsNotificationSettingsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/dmsNotificationSettingsVw',
      httpOptions1,
    );
  }

  //TMS-NotificationSettings
  getAllTMSNotificationSettings() {
    return this.http.get(
      `${this.baseUrl}` + '/tmsNotificationSettings/getAllSettings',
    );
  }

  getTMSNotificationSettingByNotificationId(notificationId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/tmsNotificationSettings/' +
      notificationId +
      '/byNotificationId',
    );
  }

  createTMSotificationSetting(tmsNotificationSettings: any) {
    return this.http.post(
      `${this.baseUrl}` + '/tmsNotificationSettings',
      tmsNotificationSettings,
    );
  }

  updateTMSNotificationSetting(tmsNotificationSettings: any) {
    return this.http.put(
      `${this.baseUrl}` + '/tmsNotificationSettings',
      tmsNotificationSettings,
    );
  }

  deleteTMSNotificationSetting(tmsNotificationSettings: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(tmsNotificationSettings),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/tmsNotificationSettings',
      httpOptions1,
    );
  }

  //QMS-NotificationSettings
  getAllQmsNotificationSettings() {
    return this.http.get(
      `${this.baseUrl}` + '/qmsNotificationSettings/getAllQNotifiSettings',
    );
  }

  getQmsNotificationSettingsByNotificationId(notificationId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsNotificationSettings/' +
      notificationId +
      '/byQNotifiId',
    );
  }

  createQmsNotificationSettings(QmsNotificationSettingsData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsNotificationSettings',
      QmsNotificationSettingsData,
    );
  }

  updateQmsNotificationSettings(QmsNotificationSettingsData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsNotificationSettings',
      QmsNotificationSettingsData,
    );
  }

  deleteQmsNotificationSettings(QmsNotificationSettingsData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(QmsNotificationSettingsData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsNotificationSettings',
      httpOptions1,
    );
  }

  orgDetails(loginUrl: any) {
    return this.http.post(
      `${this.baseUrl}` + '/organization/getOrgDetails',
      loginUrl,
    );
  }

  orgDetailsVyid(loginUrl: any) {
    return this.http.post(
      `${this.baseUrl}` + '/organization/getbyid',
      loginUrl,
    );
  }
  fetchMsalConfig(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.baseUrl + '/organization/getOrgDetails',
        JSON.stringify(data),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  registerOrganization(data: any) {
    return this.http.post(`${this.baseUrl}` + '/organization/register', data);
  }

  getAllOrganizations() {
    return this.http.get(`${this.baseUrl}/organization/all`);
  }

  getOrgs() {
    return this.http.get(`${this.baseUrl}/organization/orgs`);
  }

  getReleaseversions() {
    return this.http.get(`${this.baseUrl}` + '/organization/releaseVersion');
  }

  createOrUpgradeOrganization(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/organization/createOrUpgrade',
      data,
    );
  }

  upgradeChildOrganization(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/organization/upgradeChildOrgs',
      data,
    );
  }

  getOneQmsOrgDetails(request: any) {
    return this.http.post(`${this.baseUrl}/organization/getOrgDetails`, request);
  }

  getOneQmsOrganization(request?: any) {
    const payload = request || {};

    return this.http.post(
      `${this.baseUrl}/organization/getOrgByOrgId`,
      payload
    );
  }

  updateOneQmsOrganization(organizationData: any) {
    return this.http.put(`${this.baseUrl}` + '/organization', organizationData);
  }

  searchOrganizations() {
    return this.http.get(
      `${this.baseUrl}` + '/organization/allOrgs',
    );
  }

  getDrMode() {
    return this.http.get(`${this.baseUrl}` + '/organization/getDrModeStatus/');
  }

  switchOnDrMode(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/organization/switchOnDrMode',
      data,
    );
  }

  switchOffDrMode(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/organization/switchOffDrMode',
      data,
    );
  }

  getMainDashboardOrgList() {
    return this.http.get(`${this.baseUrl}/organization/mainDashboard`);
  }

  getIssuanceHistory(trainingId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      trainingId +
      '/' +
      version +
      '/issuanceHistory',
    );
  }

  saveReportsToDB(data: any) {
    return this.http.post(`${this.baseUrl}` + '/savedReports', data);
  }

  updateOneQmsOrganizationPriv(organizationData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/organizationPrivileges',
      organizationData,
    );
  }

  getDocumentHistory(trainingId: any, version: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      trainingId +
      '/' +
      version +
      '/viewHistory',
    );
  }
  //Home page report
  getReportGroupsHomePage() {
    return this.http.get(`${this.baseUrl}` + '/qmsCurrentUserGroupModuleTaskCountRepVw');
  }

  getReportGroupIntervals() {
    return this.http.get(`${this.baseUrl}` + '/qmsCurrentUserGroupModuleTaskIntervalRepVw');
  }

  getReportGroupAction() {
    return this.http.get(`${this.baseUrl}` + '/qmsCurrentUserGroupModuleActionStatusCountRepVw');
  }

  getReportGroupRisk() {
    return this.http.get(`${this.baseUrl}` + '/qmsCurrentUserGroupModuleRiskStatusCountRepVw');
  }

  getReportEcStatusCountHomePage() {
    return this.http.get(`${this.baseUrl}` + '/qmsCurrentUserGroupModuleEcStatusCountRepVw/module');
  }

  getReportDMSCountHomePage() {
    return this.http.get(
      `${this.baseUrl}` + '/dmsDocuments/rep',
    );
  }

  getReportDMSStatusRepHomePage() {
    return this.http.get(
      `${this.baseUrl}` + '/dmsDocuments/status',
    );
  }
  getReportDMSNStatusRepHomePage() {
    return this.http.get(
      `${this.baseUrl}` + '/dmsDocuments/nstatus',
    );
  }

  viewDocuments(data: any) {
    return this.http.put(
      `${this.baseUrl}/qmsTaskDocumentsVw/downloadDocuments`,
      data,
      {
        responseType: 'arraybuffer',
        observe: 'response',
      },
    );
  }

  // In your AppService or similar service file
  viewAdditionalPageContentFile(

    documentTypeId: any,
    filename: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsDocuments/' +
      documentTypeId +
      '/AdditionalPageContent',
      {
        responseType: 'arraybuffer',
        observe: 'response',
      },
    );
  }

  //home page report end

  downloadQmsDocuments(data: any) {
    this.http
      .put(`${this.baseUrl}` + '/qmsTaskDocumentsVw/downloadDocuments', data, {
        responseType: 'arraybuffer',
        observe: 'response',
      })
      .subscribe((response: any) => {
        if (response.status == 200) {
          const contentType = response.headers.get('content-type');
          const blob = new Blob([response.body], { type: contentType });
          const timestamp = Date.now();
          const formattedDate = new Intl.DateTimeFormat('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }).format(new Date(timestamp));
          const fileName = `OneQmsDocs_${formattedDate}_${data.documentName}.${data.documentExtn}`;
          const downloadURL = globalThis.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName;
          link.click();
        } else {
          alert('Error Occured' + response.status);
        }
      });
  }

  viewQmsEcDocument(data: any) {
    return this.http.put(
      `${this.baseUrl}/qmsTaskEcDocumentsVw/downloadDocuments`,
      data,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  downloadQmsEcDocuments(data: any) {
    this.http
      .put(
        `${this.baseUrl}` + '/qmsTaskEcDocumentsVw/downloadDocuments',
        data,
        { responseType: 'arraybuffer', observe: 'response' },
      )
      .subscribe((response: any) => {
        if (response.status == 200) {
          const contentType = response.headers.get('content-type');
          const blob = new Blob([response.body], { type: contentType });
          const timestamp = Date.now();
          const formattedDate = new Intl.DateTimeFormat('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }).format(new Date(timestamp));
          const fileName = `OneQmsDocs_${formattedDate}_${data.documentName}.${data.documentExtn}`;
          const downloadURL = globalThis.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName;
          link.click();
        } else {
          alert('Error Occured' + response.status);
        }
      });
  }

  downloadTopicAttachments(data: any) {
    this.http
      .put(
        `${this.baseUrl}` + '/oneQmsTopicAttachments/downloadAttachments',
        data,
        { responseType: 'arraybuffer', observe: 'response' },
      )
      .subscribe((response: any) => {
        if (response.status == 200) {
          const contentType = response.headers.get('content-type');
          const blob = new Blob([response.body], { type: contentType });
          const timestamp = Date.now();
          const formattedDate = new Intl.DateTimeFormat('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }).format(new Date(timestamp));
          const fileName = `OneQmsTopics_${formattedDate}_${data.documentName}.${data.documentExtn}`;
          const downloadURL = globalThis.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName;
          link.click();
        } else {
          alert('Error Occured' + response.status);
        }
      });
  }

  getTrainingCertificateTemplates() {
    return this.http.get(
      `${this.baseUrl}` + '/trainingCertificateTemplate/getAllTemplates',
    );
  }

  getTrainingCertificateTemplateById(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingCertificateTemplate/' +
      templateId +
      '/byTemplateId',
    );
  }

  createTrainingCertificateTemplate(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/trainingCertificateTemplate',
      data,
    );
  }

  updateTrainingCertificateTemplate(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/trainingCertificateTemplate',
      data,
    );
  }

  deleteTrainingCertificateTemplate(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/trainingCertificateTemplate',
      httpOptions1,
    );
  }

  copyDocumentTypes(documentTypesData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsDocumentTypesVw/copy',
      documentTypesData,
    );
  }

  moveDocument(documentData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocuments/moveDocument',
      documentData,
    );
  }

  getFormTemplateByTemplateId(templateId: any) {
    return this.http.get(`${this.baseUrl}` + "/formTemplates/" + templateId + "/bytemplateId");
  }

  getFormTemplateList() {
    return this.http.get(`${this.baseUrl}` + "/formTemplates/All");
  }

  createFormTemplate(data: any) {
    return this.http.post(`${this.baseUrl}` + '/formTemplates', data);
  }

  updateFormTemplate(data: any) {
    return this.http.put(`${this.baseUrl}` + '/formTemplates', data);
  }

  deleteFormTemplate(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/formTemplates',
      httpOptions1,
    );
  }

  getFormTemplateFieldByFieldId(fieldId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplateFields/" + fieldId + "/byfieldId");
  }

  getFieldsListByTemplateId(templateId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplateFields/" + templateId + "/byTemplateId");
  }

  createFormTemplateField(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/formSectionTemplateFields',
      data,
    );
  }

  updateFormTemplateField(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formSectionTemplateFields',
      data,
    );
  }

  deleteFormTemplateField(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/formSectionTemplateFields',
      httpOptions1,
    );
  }

  getDataTypeForMappingColumnForForm(dataType: string) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplateFields/" + dataType + "/getDataType");
  }

  getFormSectionTemplateById(templateId: any, sectionId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplate/" + templateId + "/" + sectionId + "/bytemplateIdAndsectionId");
  }

  getFormSectionTemplateList(templateId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplate/" + templateId + "/bytemplateId");
  }

  createFormSectionTemplate(data: any) {
    return this.http.post(`${this.baseUrl}` + '/formSectionTemplate', data);
  }

  updateFormSectionTemplate(data: any) {
    return this.http.put(`${this.baseUrl}` + '/formSectionTemplate', data);
  }

  deleteFormSectionTemplate(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/formSectionTemplate',
      httpOptions1,
    );
  }

  getFormTemplateUsersList(
    searchOneQmsUserVwDetails: any,
  ): Observable<oneQmsUsersInterface> {
    return this.http
      .post<oneQmsUsersInterface>(
        this.baseUrl + '/oneQmsUserPrivsVw/searchFormTemplateUsers',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }

  createFormTemplateUser(data: any) {
    return this.http.post(`${this.baseUrl}` + '/formTemplateUsers', data);
  }

  updateFormTemplateUser(data: any) {
    return this.http.put(`${this.baseUrl}` + '/formTemplateUsers', data);
  }

  deleteFormTemplateUser(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/formTemplateUsers',
      httpOptions1,
    );
  }

  getButtonLabelsForFormTemplate(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formTemplates/getButtonLabels',
      data,
    );
  }

  performButtonOperationForFormTemplate(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/formTemplates/performOperation',
      data,
    );
  }

  getFormTemplateApprovers() {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserPrivsVw/formTemplateApprovers`,
    );
  }
  getTemplatesToAddForms() {
    return this.http.get(`${this.baseUrl}` + '/forms/All');
  }

  getForms(status: any) {
    return this.http.get(`${this.baseUrl}` + "/forms/" + status + "/getForms");
  }
  getFormsMasterPage(status: any, templateId: any) {
    return this.http.get(`${this.baseUrl}` + "/forms/" + status + "/" + templateId + "/getForms");
  }
  getMatrixForForms(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/forms/' + templateId + '/getMatrixData',
    );
  }

  getMyTotal(templateId: any) {
    return this.http.get(`${this.baseUrl}` + "/forms/" + templateId + "/getMyTotalCount");
  }

  getFormByFormId(formId: any) {
    return this.http.get(`${this.baseUrl}` + "/forms/" + formId + "/byformId");
  }

  addForm(data: any) {
    return this.http.post(`${this.baseUrl}` + '/forms', data);
  }

  updateForm(data: any) {
    return this.http.put(`${this.baseUrl}` + '/forms', data);
  }

  deleteForm(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/forms',
      httpOptions1,
    );
  }

  getActiveFormFields(templateId: any, sectionId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplateFields/" + templateId + "/" + sectionId + "/bysectionIdAndtemplateId");
  }

  getSectionListByTemplateId(templateId: any, formId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionTemplate/" + templateId + '/' + formId + "/byFormIdAndtemplateId");
  }

  getFormButtonLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + '/forms/buttonLabels', data);
  }

  performButtonOperationForForm(multipartData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/forms/performOperation',
      multipartData,
    );
  }
  getFormSectionData(formId: any, sectionId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionData/" + formId + "/" + sectionId + "/byformIdAndsectionId");
  }

  addSectionData(data: any) {
    return this.http.post(`${this.baseUrl}` + '/formSectionData', data);
  }

  updateSectionData(data: any) {
    return this.http.put(`${this.baseUrl}` + '/formSectionData', data);
  }

  deleteSectionData(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/formSectionData',
      httpOptions1,
    );
  }

  getFormUsers() {
    return this.http.get(`${this.baseUrl}/oneQmsUserPrivsVw/formUsers`);
  }

  getAddedFormUsers(templateId: any, formId: any) {
    return this.http.get(`${this.baseUrl}` + "/formTemplateUsers/" + templateId + "/" + formId + "/byformIdAndtemplateId");
  }

  getUsersListForSwitch(formId: any) {
    return this.http.get(`${this.baseUrl}` + "/formTemplateUsers/" + formId + "/getUsersForSwitch");
  }

  getFormUsersByUserId(templateId: any, formId: any, userId: any) {
    return this.http.get(`${this.baseUrl}` + "/formTemplateUsers/" + templateId + "/" + formId + "/" + userId + "/bytemplateIdAndformIdAnduserId");
  }

  //dynamic grid for audit trail
  usergridddynamicFieldsForAudittrails(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getGridFieldsByProcedureForAudit',
      userDetails,
    );
  }

  getFlexibleFieldsAuditTrail(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getAuditTrailForFlexiFields',
      userDetails,
    );
  }

  getDocumentMoveHistory(documentId: any) {
    return this.http.get(`${this.baseUrl}` + '/dmsDocuments/' + documentId + "/moveHistory"
    );
  }

  //Dms Dashboard Report
  getDMSCountReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsRepVW/CountFromDmsIntervalsRepVw',
      data,
    );
  }
  getDMSCountReportValForMain(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsMainRepVW/CountFromDmsIntervalsRepVw',
      data,
    );
  }
  getTableReportDataListForDMS(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsRepVW/tableValues',
      data,
    );
  }

  getDocumentRevisionHistoryRepVw(val: any, folderPath: any) {
    const data = { val: val, folderPath: folderPath };
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocumentRevisionHistoryRepVw',
      data,
    );
  }
  getDocumentRevisionHistoryBulkRepVw(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/dmsDocumentRevisionHistoryRepVw/documentRevisionHistory',
      data,
    );
  }
  getFolderDocumentRepVw(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/distributedFoldersDocumentsRepVw/distributedFoldersDocuments',
      data,
    );
  }

  getDocumentFolderRepVw(folderPath: any, val: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/dmsFoldersRepVw/' +
      folderPath +
      '/' +
      val +
      '/byfolderPath',
    );
  }

  getExpireCheckRepVw(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocumentsExpiryCheckRepVw/expireDateTableValue',
      data,
    );
  }

  getDocumentCountRepDms(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsRepVW/dmsIntervalsCountRepVw',
      data,
    );
  }
  getDocumentCountRepDmsForMain(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsMainRepVW/dmsIntervalsCountRepVw',
      data,
    );
  }

  getDocumentTypeNameCountRepDms(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsRepVW/dmsIntervalsDocCountRepVw',
      data,
    );
  }

  getDocumentTypeNameCountRepDmsForMain(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsIntervalsMainRepVW/dmsIntervalsDocCountRepVw',
      data,
    );
  }

  getLovQueryResult(data: any) {
    return this.http.put(`${this.baseUrl}` + '/forms/getLovQueryValues', data);
  }

  getFormSectionDataByRecordId(recordId: any) {
    return this.http.get(`${this.baseUrl}` + "/formSectionData/" + recordId + "/byrecordId");
  }

  getNotificationForActivites(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsNotificationsVw/' +
      refNo +
      '/byRefNo'
    );
  }

  getNotifications() {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsNotificationsVw/All'
    );
  }
  getMsgBodyDetails(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oneQmsNotificationsVw/' +
      refNo +
      '/getMsgBodyDetails'
    );
  }
  //Audit dashboard

  getFindingReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskFindingsIntervalRepVw/findingsCount',
      data,
    );
  }
  getAuFindingReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskFindingsIntervalRepVw/aufindingsCount',
      data,
    );
  }
  getFollowupReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskFollowupsIntervalRepVw/FollowupsCount',
      data,
    );
  }
  getAuFollowupReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskFollowupsIntervalRepVw/auFollowupsCount',
      data,
    );
  }
  getFollowupTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFollowupsIntervalRepVw/followupsTableValue',
      data,
    );
  }
  getAuFollowupTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFollowupsIntervalRepVw/aufollowupsTableValue',
      data,
    );
  }
  getFindingTableVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskFindingsIntervalRepVw/findingsTableValue',
      data,
    );
  }
  getAuFindingTableVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFindingsIntervalRepVw/aufindingsTableValue',
      data,
    );
  }
  getFindingDueInDaysTableVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksFindingsDueDateVw/findingsDueDateCount',
      data,
    );
  }
  getFindingClosureInDaysTableVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFindingsClosureindaysVw/findingsClosureindaysCount',
      data,
    );
  }

  getFindingDueInDaysTableValDetails(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTasksFindingsDueDateVw/findingsDueDateTableValue',
      data,
    );
  }
  getFindingClosureInDaysTableValDetails(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFindingsClosureindaysVw/findingsTableValue',
      data,
    );
  }

  getRecommendationReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskRecommendationIntervalRepVw/recommendationIntervalVal',
      data,
    );
  }
  getAuRecommandationTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskRecommendationIntervalRepVw/aurecommendationTableValue',
      data,
    );
  }
  getRecommandationTableReportDataList(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskRecommendationIntervalRepVw/recommendationTableValue',
      data,
    );
  }
  getAuFindingSeverityReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFindingsIntervalRepVw/aufindingsSeviorityCount',
      data,
    );
  }
  getSeverityReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskFindingsIntervalRepVw/findingsSeviorityCount',
      data,
    );
  }

  getDueInDaysReportVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksDueInDaysVw/dueInDaysCount',
      data,
    );
  }

  getDueInDaysReportValTableVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksDueInDaysVw/dueInDaysTableValue',
      data,
    );
  }

  getAuFollowupDueDateVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTasksFollowupsDuedateVw/followupsDueDate',
      data,
    );
  }

  getAuFollowupDueDateTableVal(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTasksFollowupsDuedateVw/followupsDueDateTable',
      data,
    );
  }
  staticGridAuditTrailsData(userDetails: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dynamicgrid/getStaticGridFieldsByDynamicQuery',
      userDetails,
    );
  }

  getTaskDetailData(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/myPendingTasksVw/taskList',
      data,
    );
  }

  getCallCopyQmsReportTemplateProcedure(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/qmsReportTemplateVw/copyReportTemplate',
      data,
    );
  }

  //Milestone task
  getQmsAllTasksVw(module: any) {
    return this.http.get(
      `${this.baseUrl}` + '/oneQmsAllTasksVwController/' + module + '/byModule',
    );
  }


  downloadStaticPdf(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}/pdf/chartReport`, data, {
        // headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob([response], { type: response.type }),
        );
        if (filename) {
          downloadLink.setAttribute('download', filename);
        }
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  checkRaiseInRaiseCcUserPriv() {
    return this.http.get(`${this.baseUrl}/userPrivs/raiseInRaiseCcUserPriv`);
  }

  formsLogsExportReport1(data: any) {
    return this.http.post(`${this.baseUrl}` + '/excel/fromlog', data);
  }
  formsLogsExportReport(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/excel/fromlog', data, {
        // headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  formsLogsExportReportpdf(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);

    this.http
      .post(`${this.baseUrl}` + '/pdf/pdfforfromandlog', data, {
        //  headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  getCalendarEvent(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/pendingTasksCntVw/calendar',
      data,
    );
  }

  getCalendarTodayEvent() {
    return this.http.get(`${this.baseUrl}` + "/pendingTasksCntVw/calendarTodayCount");
  }

  getCalendarTodayEventDetails() {
    return this.http.get(`${this.baseUrl}` + "/myPendingTasksVw/calendarPendingTask");
  }



  getTodayEventDetails() {
    return this.http.get(`${this.baseUrl}` + "/myPendingTasksVw/todayTask");
  }

  getSelectedDateEventDetails(date: any) {
    return this.http.get(`${this.baseUrl}` + "/myPendingTasksVw/" + date + "/selectedDateTask");

  }

  getHomePageDataForTraining() {
    return this.http.get(`${this.baseUrl}` + '/training/homepage');
  }

  getHomePageDataForTrainingDetail() {
    return this.http.get(`${this.baseUrl}` + '/training/homepageDetails');
  }

  getHomePageDataForDocument() {
    return this.http.get(`${this.baseUrl}` + '/dmsFolders/homepage');
  }

  getHomePageDataForDocumentDetail() {
    return this.http.get(`${this.baseUrl}` + '/dmsFolders/homepageDetails');
  }

  getQualityGroupCount() {
    return this.http.get(`${this.baseUrl}` + "/qmsGroups/" + "qualityGroupsCount");
  }


  getHomePageDataForQualityDetail() {
    return this.http.get(`${this.baseUrl}` + "/qmsGroups/homepageDetails");
  }
  //Main Dashboard
  getDashboardCountList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskForDashboardVw/countList',
      data,
    );
  }
  getDashboardCountListAction(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsOverallActionsVw/countList',
      data,
    );
  }
  getDashboardCountListOOSAction(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsOosActionsRptVw/oosCountList',
      data,
    );
  }

  getDashboardCountListAuFindings(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsOverallAuFindingsVw/countList',
      data,
    );
  }
  getDashboardCountListForlineChart(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskForDashboardVw/TotalLineChartCountList',
      data,
    );
  }
  getDashboardCountListForlineChartOverdue(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskForDashboardVw/OverdueLineChartCountList',
      data,
    );
  }

  getDashboardCountListForlineChartOverduePercentage(data: any) {
    return this.http.put(
      `${this.baseUrl}` +
      '/qmsAllTaskForDashboardVw/OverdueLineChartCountListPercentage',
      data,
    );
  }
  getDashboardGroupCountList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskForDashboardVw/groupCountList',
      data,
    );
  }

  getDashboardTableList(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/qmsAllTaskForDashboardVw/tableData',
      data,
    );
  }
  //End Manidashboard

  getTrainingsByUserId(userId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/userTrainings/' + userId + '/byUserId',
    );
  }

  getUserEvents(status: any) {
    return this.http.get(
      `${this.baseUrl}` + '/userEvents/' + status + '/byUserStatus',
    );
  }

  getEventById(eventId: any) {
    return this.http.get(`${this.baseUrl}` + "/userEvents/" + eventId + "/byEventId");
  }

  createTodaysEvent(data: any) {
    return this.http.post(`${this.baseUrl}` + '/userEvents', data);
  }

  updateTodaysEvent(data: any) {
    return this.http.put(`${this.baseUrl}` + '/userEvents', data);
  }

  deleteTodaysEvent(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(`${this.baseUrl}` + '/userEvents', httpOptions);
  }

  getCalendarTodayEventNew() {
    return this.http.get(`${this.baseUrl}` + "/pendingTasksCntVw/calendarTask");
  }

  getAllBusinessFlow() {
    return this.http.get(`${this.baseUrl}` + '/businessprocessworkflow/All');
  }
  createBusinessFlow(data: any) {
    return this.http.post(`${this.baseUrl}` + '/businessprocessworkflow', data);
  }
  updateBusinessFlow(data: any) {
    return this.http.put(`${this.baseUrl}` + '/businessprocessworkflow', data);
  }

  deleteBusinessFlow(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/businessprocessworkflow',
      httpOptions,
    );
  }

  getAllWorkflowStages(workflowId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/businessprocessworkflowstage/' +
      workflowId +
      '/byworkflowId',
    );
  }
  getWorkflowStageById(workflowId: any, workflowStageId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/businessprocessworkflowstage/' +
      workflowId +
      '/' +
      workflowStageId +
      '/byworkflowIdandworkflowStageId',
    );
  }
  createWorkflowStage(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/businessprocessworkflowstage',
      data,
    );
  }
  updateWorkflowStage(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/businessprocessworkflowstage',
      data,
    );
  }
  deleteWorkflowStage(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/businessprocessworkflowstage',
      httpOptions,
    );
  }

  getReviewerAndApproverListForBPSetup(stage: any) {
    return this.http.get(
      `${this.baseUrl}/oneQmsUserPrivsVw/bpSetupUsers/${stage}`,
    );
  }

  getReviewerAndApproverListForBPexcutionSetup(stage: any) {
    return this.http.get(
      `${this.baseUrl}` + '/executionUserSetup/' + stage + '/bpexcuteUsers',
    );
  }

  getreorderGirdColumnList(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/nonorgGridFields/reorderGirdColumnList',
      data,
    );
  }
  getreorderGirdColumnListForFlexiField(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/nonorgGridFields/reorderGirdColumnList/flexiField',
      data,
    );
  }
  removeOrgGridFields(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/nonorgGridFields/removeOrgGridFields',
      data,
    );
  }

  updateOrgGridFields(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/nonorgGridFields/updateOrgGridFields',
      data,
    );
  }
  commitOrgGridFields(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/nonorgGridFields/commitOrgGridFields',
      data,
    );
  }

  //forms and logs reports
  getTemplateStatus(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/templatesStatus',
      data,
    );
  }
  getTableTemplateStatus(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/templatesTable',
      data,
    );
  }

  getTemplateName(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/templatesName',
      data,
    );
  }
  getFormsStatus(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/fromsVwStatus',
      data,
    );
  }

  getFormsSectionData(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/fromsSectionDataVw',
      data,
    );
  }

  getFormsSectionDataStatus(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/fromsSectionDataVwStatus',
      data,
    );
  }
  getFormsTemplateDropdown(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/getTemplateDropDwon',
      data,
    );
  }
  getFormsDropdown(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/getFormsDropDown',
      data,
    );
  }
  getFormssectionDropdown(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/getSectionDropDown',
      data,
    );
  }

  getTemplateFormssectionDropdown(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/getTemplateSectionDropDown',
      data,
    );
  }

  getTableFormsStatus(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/fromsVwTableValue',
      data,
    );
  }

  getTableFormsSectionDataStatus(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/fromsSectionDataTableValue',
      data,
    );
  }
  getTableFormsSectionDataStatusForMore(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/formsAndLogsRep/fromsSectionDataTableValueForMore',
      data,
    );
  }
  //end reports

  //Date Convertion
  dateZoneConvertion(date: any) {
    let spliteddata = date.toString().split(' ');
    for (const element of spliteddata) {
      if (element.includes('GMT')) {
        let splitedGMTData = element.split('GMT');
        if (splitedGMTData[1].includes('+')) {
          let zone = splitedGMTData[1].slice(1);
          let hs: any = zone[0] + '' + zone[1];
          let ms: any = +zone[2] + '' + zone[3];
          date.setHours(12 + +hs);
          date.setMinutes(+ms);
          date.setSeconds(0);
        } else if (splitedGMTData[1].includes('-')) {
          let zone = splitedGMTData[1].slice(1);
          let hs: any = zone[0] + '' + zone[1];
          let ms: any = +zone[2] + '' + zone[3];
          date.setHours(12 - +hs);
          date.setMinutes(+ms);
          date.setSeconds(0);
        }
      }
    }
    return date;
  }

  dateZoneConvertionAu(date: Date): string {
    // Convert local date to a UTC date string (without shifting time)
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return new Date(
      Date.UTC(year, month, day, hours, minutes, seconds),
    ).toISOString();
  }

  convertUTCToLocal(utcDateStr: string): Date {
    // Parse the UTC date
    const utcDate = new Date(utcDateStr);

    // Extract year, month, day, hours, minutes, seconds (without changing time)
    const year = utcDate.getUTCFullYear();
    const month = utcDate.getUTCMonth();
    const date = utcDate.getUTCDate();
    const hours = utcDate.getUTCHours();
    const minutes = utcDate.getUTCMinutes();
    const seconds = utcDate.getUTCSeconds();

    // Create new Date object with local timezone but same time
    return new Date(year, month, date, hours, minutes, seconds);
  }

  getFeedbackTemplatesList() {
    return this.http.get(`${this.baseUrl}` + '/feedbackTemplates/All');
  }

  getFeedbackTemplateById(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/feedbackTemplates/' + templateId + '/bytemplatedId',
    );
  }

  createFeedbackTemplate(data: any) {
    return this.http.post(`${this.baseUrl}` + '/feedbackTemplates', data);
  }

  updateFeedbackTemplate(data: any) {
    return this.http.put(`${this.baseUrl}` + '/feedbackTemplates', data);
  }

  deleteFeedbackTemplate(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/feedbackTemplates',
      httpOptions,
    );
  }

  addFeedbackForm(data: any) {
    return this.http.post(`${this.baseUrl}` + '/feedbackForms', data);
  }

  getFeedbackTemplateQuestionList(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackTemplateQuestions/' +
      templateId +
      '/bytemplateId',
    );
  }

  getFeedbackTemplateQuestionListForMyTask(formId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/feedbackTemplateQuestions/' + formId + '/forMyTask',
    );
  }

  getFeedbackQueWithAnsw(templateId: any, formId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackFormUserQuestions/' +
      templateId +
      '/' +
      formId +
      '/bytemplateIdAndformId',
    );
  }

  getFeedbackTemplateQuestionListForILT(
    feedbackTemplateId: any,
    formId: any,
    userId: any,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackTemplateQuestions/' +
      feedbackTemplateId +
      '/' +
      formId +
      '/' +
      userId +
      '/forILT',
    );
  }

  getFeedbackTemplateQuestionById(templateId: any, questionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackTemplateQuestions/' +
      templateId +
      '/' +
      questionId +
      '/bytemplateIdAndquestionId',
    );
  }

  createFeedbackTemplateQuestion(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/feedbackTemplateQuestions',
      data,
    );
  }

  updateFeedbackTemplateQuestion(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/feedbackTemplateQuestions',
      data,
    );
  }

  deleteFeedbackTemplateQuestion(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/feedbackTemplateQuestions',
      httpOptions,
    );
  }

  createFeedbackFormUserQuestion(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/feedbackFormUserQuestions',
      data,
    );
  }

  submitFeedbackResponse(data: any) {
    return this.http.put(`${this.baseUrl}` + '/feedbackForms/submit', data);
  }

  reinitiateFeedbackForUser(data: any) {
    return this.http.put(`${this.baseUrl}` + '/feedbackForms/reinitiate', data);
  }

  gettaskStatusSetupListByModule(module: any) {
    return this.http.get(
      `${this.baseUrl}` + '/taskStatusSetup/' + module + '/tastStatusList',
    );
  }

  gettaskStatusSetupByStatus(module: any, status: any) {
    let data = {
      module: module,
      status: status,
    };
    return this.http.post(
      `${this.baseUrl}` + '/taskStatusSetup/taskstatussetuplist',
      data,
    );
  }

  getDocumentNameForDownload(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/dmsDocuments/getDocumentNameForDownload',
      data,
    );
  }

  getUsersDetailsFromOneQmsUsersWithRoles(
    searchOneQmsUserVwDetails: any,
  ): Observable<any> {
    return this.http
      .post<any>(
        this.baseUrl + '/oneQmsUsersWithRolesVw/searchUsers',
        JSON.stringify(searchOneQmsUserVwDetails),
        this.httpOptions,
      )
      .pipe(
        catchError((error) =>
          throwError(
            () => new Error(`${error.status} - ${error.error?.message}`),
          ),
        ),
      );
  }


  getMyTags() {
    return this.http.get(`${this.baseUrl}` + "/homepagetags/All");
  }

  deleteHomePageTags(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(`${this.baseUrl}` + '/homepagetags', httpOptions);
  }

  createhomepagetags(data: any) {
    return this.http.post(`${this.baseUrl}` + '/homepagetags', data);
  }

  getOneQmsOrganizationReportImage() {
    return this.http.get(`${this.baseUrl}` + '/oneQmsOrgReportImages/getAllReportImages');
  }

  getOrgRepImgModule() {
    return this.http.get(`${this.baseUrl}` + '/oneQmsOrgReportImages/module');
  }

  addReportImage(uploadLogoData: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oneQmsOrgReportImages',
      uploadLogoData,
    );
  }
  updateReportImage(uploadLogoData: any) {
    return this.http.put(
      `${this.baseUrl}` + '/oneQmsOrgReportImages',
      uploadLogoData,
    );
  }

  deleteReportImage(uploadLogoData: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(uploadLogoData),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/oneQmsOrgReportImages',
      httpOptions1,
    );
  }

  getQmsReportLogoByModuleAndGroupId(module: any, groupId: any,) {
    return this.http.get(`${this.baseUrl}` + '/oneQmsOrgReportImages/' + module + '/' + groupId + "/moduleAndGroupId");
  }

  addIpAddress(data: any) {
    return this.http.post(`${this.baseUrl}` + '/orgIpAddressRegistry', data);
  }
  updateIpAddress(data: any) {
    return this.http.put(`${this.baseUrl}` + '/orgIpAddressRegistry', data);
  }

  deleteIpAddress(data: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(data),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/orgIpAddressRegistry',
      httpOptions1,
    );
  }
  getSavedReportsForHomePage() {
    return this.http.get(
      `${this.baseUrl}` + '/savedReports/forHomePage');
  }

  getgridfilters(pageName: any) {
    return this.http.get(`${this.baseUrl}` + '/gridfilters/' + pageName + "/byPageName");
  }

  getAvgFinalScroe(templateId: any, formId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackFormUserQuestionsVw/' +
      templateId +
      '/' +
      formId +
      '/bytemplateIdAndformId',
    );
  }
  getAvgAvgQuestionScroe(templateId: any, formId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackFormUserQuestionsVw/' +
      templateId +
      '/' +
      formId +
      '/AvgQuestionScroe',
    );
  }
  getAvgInduQuestionScroe(templateId: any, formId: any, questionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/feedbackFormUserQuestionsVw/' +
      templateId +
      '/' +
      formId +
      '/' +
      questionId +
      '/bytemplateIdAndformIdAndquestionId',
    );
  }

  downloadSavedReport(reportId: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .get(
        `${this.baseUrl}` +
        '/savedReports/' +
        reportId + '/downloadSavedReport',
        {
          // headers,
          responseType: 'blob' as 'json'
        },
      )
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  downloadPdfForILT(data: any, filename: any) {
    // const token = 'my JWT';
    // const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http
      .post(`${this.baseUrl}` + '/pdf/ilt', data, {
        // headers,
        responseType: 'blob' as 'json',
      })
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        if (filename) downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessingRep = false;
      });
  }

  async clearcache() {
    this.router.navigate(['dashboard']);
    setTimeout(() => {
      globalThis.location.reload();
      return true;
    }, 750);
  }

  performEditOnlineForDocument(data: any) {
    return this.http.post(`${this.baseUrl}` + '/onlineedit/upload', data);
  }
  performonlieneditAssignUserre(data: any) {
    return this.http.post(`${this.baseUrl}` + '/onlineedit/coreviwer', data);
  }
  performonlieneditcoauthor(data: any) {
    return this.http.post(`${this.baseUrl}` + '/onlineedit/coauthor', data);
  }
  performonlieneditcheckin(data: any) {
    return this.http.post(`${this.baseUrl}` + '/onlineedit/chekin', data);
  }
  cancelonlineedit(data: any) {
    return this.http.post(`${this.baseUrl}` + '/onlineedit/cancelonline', data);
  }
  collabrativeReviwCancel(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/onlineedit/collabrativeReviwCancel',
      data,
    );
  }
  varifyOnliedoc(data: any) {
    return this.http.post(`${this.baseUrl}` + '/onlineedit/viewfile', data, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  updateDocumentReportHeaderTemplate(data: any) {
    return this.http.put(
      `${this.baseUrl}` + '/documentReportHeaderTemplate',
      data,
    );
  }

  addDocumentReportHeaderTemplate(data: any) {
    return this.http.post(
      `${this.baseUrl}` + '/documentReportHeaderTemplate',
      data,
    );
  }
  deleteDocumentReportHeaderTemplate(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(
      `${this.baseUrl}` + '/documentReportHeaderTemplate',
      httpOptions,
    );
  }
  getDocumentReportHeaderTemplateById(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/documentReportHeaderTemplate/' +
      templateId +
      '/bytemplateId',
    );
  }

  getAllDocumentReportHeaderTemplates() {
    return this.http.get(
      `${this.baseUrl}` + '/documentReportHeaderTemplate/All',
    );
  }
  getAutofillFormulaValues(fieldId: any) {
    return this.http.get(
      `${this.baseUrl}/formSectionTemplateFields/${fieldId}/autofillFormula`,
      { responseType: 'text' }  // 👈 Ensures the response is treated as plain text
    );
  }

  getAllLabTemplate() {
    return this.http.get(`${this.baseUrl}` + '/labTemplate/getAllLabTemplate');
  }

  getTemplateByOrgIdAndTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` + '/labTemplate/' + templateId + '/byTemplateId',
    );
  }

  createOosLabInvestigationTemplate(oosTemplate: any) {
    return this.http.post(`${this.baseUrl}` + '/labTemplate', oosTemplate);
  }

  updateOosLabInvestigationTemplate(oosTemplate: any) {
    return this.http.put(`${this.baseUrl}` + '/labTemplate', oosTemplate);
  }

  deleteOosLabInvestigationTemplate(oosTemplate: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(oosTemplate),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/labTemplate',
      httpOptions1,
    );
  }

  getAllCategoryByTemplateId(templateId: number) {
    return this.http.get(
      `${this.baseUrl}` +
      '/labTemplateFields/' +
      templateId +
      '/getAllCategory',
    );
  }

  getAllFieldsByTemplateId(templateId: number) {
    return this.http.get(
      `${this.baseUrl}` + '/labTemplateFields/' + templateId + '/getAllFields',
    );
  }

  getCategoryById(categoryOrFieldId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/labTemplateFields/' +
      categoryOrFieldId +
      '/byCategoryId',
    );
  }

  getAllFieldsByCategoryName(categoryName: string) {
    return this.http.get(
      `${this.baseUrl}` +
      '/labTemplateFields/' +
      categoryName +
      '/byCategoryName',
    );
  }

  getFieldById(categoryOrFieldId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/labTemplateFields/' +
      categoryOrFieldId +
      '/byFieldId',
    );
  }

  createOosCategoryOrField(categoryOrField: any) {
    return this.http.post(
      `${this.baseUrl}` + '/labTemplateFields',
      categoryOrField,
    );
  }

  updateOosCategoryOrField(categoryOrField: any) {
    return this.http.put(
      `${this.baseUrl}` + '/labTemplateFields',
      categoryOrField,
    );
  }

  deleteOosCategoryOrField(categoryOrField: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(categoryOrField),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/labTemplateFields',
      httpOptions1,
    );
  }

  getAllByOosNoAndQcDept(oosNo: any, qcSubDepartment: string, phase: string) {
    return this.http.get(
      `${this.baseUrl}` +
      '/oosQuestions/' +
      oosNo +
      '/' +
      qcSubDepartment +
      '/' +
      phase +
      '/byOosNoQCDeptPhase',
    );
  }

  createOosQuestion(field: any) {
    return this.http.post(`${this.baseUrl}` + '/oosQuestions', field);
  }

  updateOosQuestion(field: any) {
    return this.http.put(`${this.baseUrl}` + '/oosQuestions', field);
  }

  deleteOosQuestion(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/oosQuestions',
      httpOptions1,
    );
  }

  reorderCategory(oosCategory: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oosQuestions/reorderCategory',
      oosCategory,
    );
  }

  reorderFields(oosFields: any) {
    return this.http.post(
      `${this.baseUrl}` + '/oosQuestions/reorderFields',
      oosFields,
    );
  }

  getAllImpactAssessmentTemplateByModule(module: any) {
    return this.http.get(
      `${this.baseUrl}` + '/impactAssessmentTemplate/' + module + '/byModule',
    );
  }

  getImpactAssessmentTemplateByTemplateId(templateId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/impactAssessmentTemplate/' +
      templateId +
      '/byTemplateId',
    );
  }

  createImpactAssessmentTemplate(field: any) {
    return this.http.post(
      `${this.baseUrl}` + '/impactAssessmentTemplate',
      field,
    );
  }

  updateImpactAssessmentTemplate(field: any) {
    return this.http.put(
      `${this.baseUrl}` + '/impactAssessmentTemplate',
      field,
    );
  }

  deleteImpactAssessmentTemplate(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/impactAssessmentTemplate',
      httpOptions1,
    );
  }

  geAllImpactAssessmentFieldsByTemplateId(templateId: any) {
    return this.http.get(`${this.baseUrl}` + "/impactAssessmentFields/" + templateId + "/byTemplateId");
  }

  getImpactAssessmentFieldByFieldId(fieldId: any) {
    return this.http.get(`${this.baseUrl}` + "/impactAssessmentFields/" + fieldId + "/byFieldId");
  }

  createImpactAssessmentField(field: any) {
    return this.http.post(`${this.baseUrl}` + '/impactAssessmentFields', field);
  }

  updateImpactAssessmentField(field: any) {
    return this.http.put(`${this.baseUrl}` + '/impactAssessmentFields', field);
  }

  deleteImpactAssessmentField(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/impactAssessmentFields',
      httpOptions1,
    );
  }

  getAllImpactsByRefNo(refNo: any) {
    return this.http.get(
      `${this.baseUrl}` + '/impactAssessment/' + refNo + '/byRefNo',
    );
  }

  getImpactByRefNoAndFieldId(refNo: any, fieldId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/impactAssessment/' +
      refNo +
      '/' +
      fieldId +
      '/byRefNoFieldId',
    );
  }

  createImpactAssessment(field: any) {
    return this.http.post(`${this.baseUrl}` + '/impactAssessment', field);
  }

  updateImpactAssessment(field: any) {
    return this.http.put(`${this.baseUrl}` + '/impactAssessment', field);
  }

  deleteImpactAssessment(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/impactAssessment',
      httpOptions1,
    );
  }

  getDocumentsForActions(refNo: any, actionId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsTaskDocumentsVw/' +
      refNo +
      '/' +
      actionId +
      '/byRefNoActionId',
    );
  }

  getAllInstruments() {
    return this.http.get(
      `${this.baseUrl}` + '/instrumentMaster/getAllInstruments',
    );
  }

  getInstrumentByInstrumentNo(instrumentNo: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/instrumentMaster/' +
      instrumentNo +
      '/byInstrumentNo',
    );
  }

  createInstrument(field: any) {
    return this.http.post(`${this.baseUrl}` + '/instrumentMaster', field);
  }

  updateInstrument(field: any) {
    return this.http.put(`${this.baseUrl}` + '/instrumentMaster', field);
  }

  deleteInstrument(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/instrumentMaster',
      httpOptions1,
    );
  }

  getAllCheckListTemplateByModule(module: any) {
    return this.http.get(`${this.baseUrl}` + '/checkListTemplate/' + module + '/getAllCheckListByModule');
  }

  getCheckListTemplateByTemplateId(templateId: any) {
    return this.http.get(`${this.baseUrl}` + '/checkListTemplate/' + templateId + '/byTemplateId',
    );
  }

  createCheckListTemplate(field: any) {
    return this.http.post(`${this.baseUrl}` + '/checkListTemplate', field);
  }

  updateCheckListTemplate(field: any) {
    return this.http.put(`${this.baseUrl}` + '/checkListTemplate', field);
  }

  deleteCheckListTemplate(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/checkListTemplate',
      httpOptions1,
    );
  }

  geAllCheckListTemplateFieldsByTemplateId(templateId: any,) {
    return this.http.get(`${this.baseUrl}` + '/checkListFields/' + templateId + '/byTemplateId');
  }

  getCheckListTemplateFieldByFieldId(fieldId: any) {
    return this.http.get(`${this.baseUrl}` + '/checkListFields/' + fieldId + '/byFieldId');
  }

  createCheckListTemplateField(field: any) {
    return this.http.post(`${this.baseUrl}` + '/checkListFields', field);
  }

  updateCheckListTemplateField(field: any) {
    return this.http.put(`${this.baseUrl}` + '/checkListFields', field);
  }

  deleteCheckListTemplateField(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/checkListFields',
      httpOptions1,
    );
  }

  getAllCheckList(refNo: any, stageName: any, userId?: any) {
    return this.http.get(`${this.baseUrl}/checkList/${refNo}/${stageName}/getAllCheckList`, { params: { ...(userId != null && { userId }) } });
  }

  createCheckList(field: any) {
    return this.http.post(`${this.baseUrl}` + '/checkList', field);
  }

  updateCheckList(field: any) {
    return this.http.put(`${this.baseUrl}` + '/checkList', field);
  }

  deleteCheckList(field: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(field),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/checkList',
      httpOptions1,
    );
  }

  downloadDocumentsDmsForPrintPreview(
    data: any,
    filename: any,
    loaderskip: boolean = false,
  ) {
    let headers = new HttpHeaders();
    if (loaderskip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }

    return this.http.post(
      `${this.baseUrl}/dmsDocuments/getdcumntPrintPreview`,
      data,
      {
        headers: headers,
        responseType: 'arraybuffer',
        observe: 'response',
      },
    );
  }

  downloadDocumentsDmsForDocPreview(data: any, filename: any) {
    return this.http.post(
      `${this.baseUrl}` + '/dmsDocuments/getDocPreview',
      data,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }
  // downloadDocumentsDmsForPrint(data: any, filename: any) {
  //   return this.http.post(
  //     `${this.baseUrl}` + '/dmsDocuments/getdcumntPrint',
  //     data,
  //   );
  // }

  // --- DMS Issuance Request APIs ---

  // Create a new Issuance Request
  createDmsIssuanceRequest(data: any) {
    return this.http.post(`${this.baseUrl}` + '/dmsIssuanceRequestVw', data);
  }

  getAllEcFindings(refNo: any, ecId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsEcFindings/' +
      refNo +
      '/' +
      ecId +
      '/byRefNoEcId',
    );
  }

  getEcFindingsById(refNo: any, ecId: any, findingEcId: any) {
    return this.http.get(
      `${this.baseUrl}` +
      '/qmsEcFindings/' +
      '/' +
      refNo +
      '/' +
      ecId +
      '/' +
      findingEcId +
      '/byRefNoEcIdFinEcId',
    );
  }

  createEcFindings(ecFindings: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsEcFindings', ecFindings);
  }

  updateEcFindings(ecFindings: any) {
    return this.http.put(`${this.baseUrl}` + '/qmsEcFindings', ecFindings);
  }

  deleteEcFindings(ecFindings: any) {
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }),
      body: JSON.stringify(ecFindings),
    };
    return this.http.delete<oneQmsUsersInterface>(
      this.baseUrl + '/qmsEcFindings',
      httpOptions1,
    );
  }

  public getUtcTime(loaderskip: boolean) {
    let headers = new HttpHeaders();
    if (loaderskip) {
      headers = headers.set('X-Skip-Loader', 'true');
    }
    return this.http.get(`${this.baseUrl}/timezones/getUtcTime`, { headers });
  }

  getDistinctMasterModules(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsGroupMaster/getDistinctModules', data);
  }

  getDistinctMasterGroups(data: any) {
    return this.http.post(`${this.baseUrl}` + '/qmsGroupMaster/getDistinctGroups', data);
  }

  getDepartmentMasterByOrgIds(data: any) {
    return this.http.post(`${this.baseUrl}` + '/oneQmsDepartment', data);
  }

  getMasterMainModuleByOrgIds(data: any) {
    return this.http.post(`${this.baseUrl}` + '/oneQmsOrgModulePrivs', data);
  }

  getAIContentsList(
    trainingId: number,
    version: number,
  ) {
    return this.http.get(
      `${this.baseUrl}` +
      '/trainingContentsAi/' +
      trainingId +
      '/' +
      version +
      '/',
    );
  }
  // --- Organization Printers APIs ---

  getOrgPrinters() {
    return this.http.get(`${this.baseUrl}/orgPrinters/findAllPrinters`);
  }

  getOrgPrinterById(printerId: any) {
    return this.http.get(`${this.baseUrl}/orgPrinters/${printerId}/byPrinterId`);
  }

  addOrgPrinter(data: any) {
    return this.http.post(`${this.baseUrl}/orgPrinters`, data);
  }

  updateOrgPrinter(data: any) {
    return this.http.put(`${this.baseUrl}/orgPrinters`, data);
  }

  deleteOrgPrinter(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data,
    };
    return this.http.delete(`${this.baseUrl}/orgPrinters`, httpOptions);
  }
  private getToken(): Observable<string> {
    return this.http
      .post<any>(
        `${this.TRAY_URL}/api/auth/token`,
        {
          username: this.message,
          sessionId: 'session-' + Date.now(),
        },
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'X-Tray-Auth-Secret': 'YOUR_SECURE_RANDOM_SECRET_KEY',
          }),
        },
      )
      .pipe(map((res) => res.token));
  }
  getPrinters(): Observable<{ printers: string[]; default: string }> {
    return this.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        return this.http.get<{ printers: string[]; default: string }>(
          `${this.TRAY_URL}/api/printers`,
          { headers },
        );
      }),
    );
  }

  getOrgPrintLogs() {
    return this.http.get(`${this.baseUrl}/orgPrintLog/findAllLogs`);
  }

  createEsignEnvelope(data: any) {
    return this.http.post(`${this.baseUrl}/esign/createEnvelope`, data);
  }

  sendEsignEnvelope(envelopeId: number, sessionUserId: any) {
    return this.http.post(
      `${this.baseUrl}/esign/sendEnvelope/${envelopeId}/${sessionUserId}`,
      {},
    );
  }

  performEsignAction(data: any) {
    return this.http.post(`${this.baseUrl}/esign/performAction`, data);
  }

  saveFinalSignedDocument(envelopeId: number, sessionUserId: any, file: Blob) {
    const formData = new FormData();
    formData.append('file', file, 'signed_document.pdf');
    return this.http.post(
      `${this.baseUrl}/esign/saveFinalDocument/${envelopeId}/${sessionUserId}`,
      formData,
    );
  }

  getEsignEnvelope(envelopeId: number) {
    return this.http.get(`${this.baseUrl}/esign/getEnvelope/${envelopeId}`);
  }

  getEsignEnvelopesByDocument(documentId: any, version: any) {
    return this.http.get(`${this.baseUrl}/esign/byDocument/${documentId}/${version}`);
  }
  getDocumentAsPdfForEsign(
    documentId: any,
    version: any,
  ) {
    return this.http.get(
      `${this.baseUrl}/dmsDocuments/${documentId}/${version}/documentAsPdfForEsign`,
      { responseType: 'arraybuffer', observe: 'response' },
    );
  }

  finalizeEsignEnvelope(envelopeNo: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/esign/finalize/${envelopeNo}`,
      {},
    );
  }

  getEsignFinalDocumentUrl(envelopeNo: any): string {
    return `${this.baseUrl}/esign/finalDocument/${envelopeNo}`;
  }

  getFinalDocumentBlob(envelopeNo: any): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/esign/finalDocument/${envelopeNo}`, { responseType: 'blob' },);
  }
  getAllAiTrainings() {
    return this.http.get(`${this.baseUrl}/aiTrainingsVwController/allTrainings`);
  }

  getAllAiTrainingContents() {
    return this.http.get(`${this.baseUrl}/aiTrainingContentsVwController/allContents`);
  }

  getAllAiUserTrnContents() {
    return this.http.get(`${this.baseUrl}/aiUserTrnContentsVwController/allUserTrnContents`);
  }

  getAllAiTrnQuestions() {
    return this.http.get(`${this.baseUrl}/aiTrnQuestionsVwController/allQuestions`);
  }
}
